// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2728%27 height=%2728%27%3E%3Ccircle cx=%271.5%27 cy=%271.5%27 r=%271.5%27 fill=%27%23008BB1%27 fill-opacity=%270.16%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2728%27 height=%2728%27%3E%3Ccircle cx=%271.5%27 cy=%271.5%27 r=%271.5%27 fill=%27%23008BB1%27 fill-opacity=%270.14%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2714%27 height=%2714%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23008BB1%27 stroke-width=%272.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================================
   Clametis Pharma — Design System v3 (Professional / Premium)
   Loaded AFTER App.css so these tokens win. Aggressively overrides the
   template's legacy hero/section/banner rules so the layout stays sane.
   ========================================================================= */

:root {
  /* Brand */
  --brand-primary: #008BB1;
  --brand-primary-hover: #00A8D4;
  --brand-primary-pressed: #00728F;
  --brand-primary-soft: #E6F5F9;
  --brand-primary-tint: #F4FAFC;
  --brand-secondary: #F17732;
  --brand-secondary-hover: #F58C4F;
  --brand-secondary-soft: #FDECE1;
  --brand-dark: #0B2536;
  --brand-dark-2: #0F3145;

  --grad-brand: linear-gradient(135deg, #00A8D4 0%, #007A9C 100%);
  --grad-brand-soft: linear-gradient(135deg, #E6F5F9 0%, #F4FAFC 100%);
  --grad-hero-bg: radial-gradient(1200px 800px at 90% -10%, rgba(0, 168, 212, 0.14), transparent 60%),
                  radial-gradient(900px 600px at -10% 110%, rgba(241, 119, 50, 0.08), transparent 60%),
                  linear-gradient(180deg, #FCFDFE 0%, #F4FAFC 100%);

  /* Neutrals — cool grey, editorial */
  --ink-950: #0A1220;
  --ink-900: #101A2C;
  --ink-800: #1B2740;
  --ink-700: #2C3A55;
  --ink-600: #495267;
  --ink-500: #6B7385;
  --ink-400: #96A0B4;
  --ink-300: #C4CDDD;
  --ink-200: #E4EAF3;
  --ink-100: #F3F6FB;
  --ink-50:  #FAFBFD;
  --surface: #FFFFFF;
  --surface-2: #F7FAFC;

  /* Radius */
  --radius-xs: 6px;
  --radius-sm: 10px;
  --radius-md: 14px;
  --radius-lg: 20px;
  --radius-xl: 28px;
  --radius-2xl: 36px;
  --radius-pill: 999px;

  /* Shadow */
  --shadow-xs: 0 1px 2px rgba(11, 37, 54, 0.06);
  --shadow-sm: 0 4px 12px rgba(11, 37, 54, 0.06), 0 1px 2px rgba(11, 37, 54, 0.04);
  --shadow-md: 0 12px 32px rgba(11, 37, 54, 0.08), 0 2px 6px rgba(11, 37, 54, 0.04);
  --shadow-lg: 0 24px 60px rgba(11, 37, 54, 0.12), 0 4px 12px rgba(11, 37, 54, 0.05);
  --shadow-xl: 0 40px 80px rgba(11, 37, 54, 0.18);
  --shadow-cta: 0 12px 28px rgba(0, 139, 177, 0.28), 0 2px 6px rgba(0, 139, 177, 0.16);
  --shadow-cta-hover: 0 16px 36px rgba(0, 139, 177, 0.36), 0 4px 12px rgba(0, 139, 177, 0.22);
  --shadow-cta-secondary: 0 12px 28px rgba(241, 119, 50, 0.28), 0 2px 6px rgba(241, 119, 50, 0.16);

  /* Motion */
  --ease-out: cubic-bezier(0.16, 1, 0.3, 1);
  --dur-fast: 150ms;
  --dur: 250ms;
  --dur-slow: 400ms;

  /* Typography — Poppins throughout (body/ui/display); italic weight stands in
     for the old serif-accent role so <em> emphasis still reads as a distinct touch. */
  --font-sans: "Poppins", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  --font-display: "Poppins", system-ui, -apple-system, sans-serif;
  --font-serif: "Poppins", system-ui, -apple-system, sans-serif;

  --fs-hero: clamp(2.5rem, 3.6vw + 1rem, 4rem);
  --fs-display: clamp(2rem, 2.6vw + 1rem, 3.25rem);
  --fs-h1: clamp(1.875rem, 2vw + 1rem, 2.75rem);
  --fs-h2: clamp(1.625rem, 1.2vw + 1rem, 2.25rem);
  --fs-h3: clamp(1.25rem, 0.5vw + 1rem, 1.5rem);
  --fs-h4: 1.25rem;
  --fs-h5: 1.125rem;
  --fs-body: 1rem;
  --fs-body-lg: 1.0625rem;
  --fs-body-sm: 0.9375rem;
  --fs-caption: 0.8125rem;
  --fs-eyebrow: 0.75rem;

  --container-w: 1280px;
  --container-pad: 24px;

  /* Bootstrap overrides */
  --bs-primary: #008BB1;
  --bs-primary-rgb: 0, 139, 177;
  --bs-link-color: #008BB1;
  --bs-link-color-rgb: 0, 139, 177;
  --bs-link-hover-color: #00728F;
  --bs-link-hover-color-rgb: 0, 114, 143;
  --bs-body-color: #495267;
  --bs-body-color-rgb: 73, 82, 103;
  --bs-heading-color: #101A2C;
  --bs-body-font-family: var(--font-sans);
  --bs-body-font-weight: 500;
  --bs-body-line-height: 1.6;
}

/* =========================================================================
   NEUTRALIZE TEMPLATE HERO — old App.css has broken rules that force
   height: 1085px and absolutely-position .inner-content off-canvas. Kill.
   ========================================================================= */

.main-banner {
  height: auto !important;
  min-height: 0 !important;
  padding: 152px 0 108px !important;
  background:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}),
    var(--grad-hero-bg) !important;
  background-repeat: repeat, no-repeat !important;
  background-position: center, center !important;
  background-size: 28px 28px, cover !important;
  position: relative !important;
  overflow: hidden !important;
  z-index: 1 !important;
  display: block !important;
}
.main-banner::before,
.main-banner::after,
.main-banner:before,
.main-banner:after {
  content: none !important;
  display: none !important;
  background: none !important;
}

/* The template forces .inner-content absolute-centered — undo entirely.
   Keep .container's own Bootstrap max-width + auto margins working. */
.main-banner .inner-content {
  position: static !important;
  top: auto !important;
  left: auto !important;
  right: auto !important;
  bottom: auto !important;
  transform: none !important;
  z-index: 2;
}

.main-banner h1,
.main-banner .h1 {
  font-family: var(--font-display) !important;
  font-weight: 700 !important;
  font-size: var(--fs-hero) !important;
  color: var(--ink-900) !important;
  line-height: 1.06 !important;
  letter-spacing: -0.035em !important;
  margin: 0 0 24px !important;
  padding: 0 !important;
  background: none !important;
  background-image: none !important;
}
.main-banner h1 em {
  font-family: var(--font-serif) !important;
  font-weight: 400 !important;
  font-style: italic !important;
  color: var(--brand-primary) !important;
  letter-spacing: -0.02em !important;
}

/* Hero eyebrow badge — pill chip with icon-in-circle */
.main-banner .hero-badges {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  background: var(--surface);
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-pill);
  padding: 6px 16px 6px 6px;
  margin-bottom: 20px;
  box-shadow: var(--shadow-xs);
  font-size: 13px;
  font-weight: 600;
  color: var(--ink-700);
  letter-spacing: 0.01em;
}
.main-banner .hero-badges .dot {
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--brand-primary-soft);
  color: var(--brand-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Floating trust chip overlapping the hero photo — premium SaaS touch */
.main-banner .hero-float-chip {
  position: absolute;
  left: -20px;
  bottom: 28px;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--surface);
  border-radius: var(--radius-lg);
  padding: 14px 18px;
  box-shadow: var(--shadow-lg);
  max-width: 230px;
}
.main-banner .hero-float-chip .icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 12px;
  background: var(--brand-secondary-soft);
  color: var(--brand-secondary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.main-banner .hero-float-chip .label {
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--ink-500);
  font-weight: 600;
  line-height: 1.3;
}
.main-banner .hero-float-chip .value {
  font-size: 14px;
  font-weight: 700;
  color: var(--ink-900);
  line-height: 1.3;
}
@media (max-width: 991px) {
  .main-banner .hero-float-chip { left: 12px; bottom: -20px; }
}
@media (max-width: 575px) {
  .main-banner .hero-float-chip { display: none; }
}

.main-banner .banner-img {
  position: relative !important;
  animation: none !important;
  -webkit-animation: none !important;
  margin: 0 !important;
  padding: 20px !important;
  display: block !important;
}
.main-banner .banner-img::before {
  content: "" !important;
  display: block !important;
  position: absolute !important;
  inset: 24px !important;
  background: var(--grad-brand) !important;
  border-radius: var(--radius-2xl) !important;
  transform: rotate(-4deg) !important;
  z-index: 0 !important;
  box-shadow: var(--shadow-lg) !important;
}
.main-banner .banner-img img {
  position: relative !important;
  z-index: 1 !important;
  border-radius: var(--radius-2xl) !important;
  box-shadow: var(--shadow-lg) !important;
  background: #fff !important;
  width: 100% !important;
  height: auto !important;
  display: block !important;
}
.main-banner .title-ext {
  background: none !important;
  background-image: none !important;
  margin: 0 0 16px !important;
  padding: 0 !important;
  font-size: var(--fs-eyebrow) !important;
  color: var(--brand-primary) !important;
  text-transform: uppercase !important;
  letter-spacing: 0.14em !important;
  font-weight: 600 !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 10px !important;
}
.main-banner .pt-img1,
.main-banner .pt-img2,
.main-banner .pt-img3,
.main-banner .pt-img4,
.main-banner .pt-img5 { display: none !important; }

/* Hero stats — 3 columns, dividers between, editorial serif numerals */
.main-banner .hero-stats {
  display: grid !important;
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  gap: 0 !important;
  border-top: 1px solid var(--ink-200) !important;
  max-width: 560px !important;
  margin: 32px 0 0 !important;
  padding: 24px 0 0 !important;
}
.main-banner .hero-stats > li {
  padding: 0 20px !important;
  border-left: 1px solid var(--ink-200);
}
.main-banner .hero-stats > li:first-child {
  padding-left: 0 !important;
  border-left: none;
}
.main-banner .hero-stats > li:last-child {
  padding-right: 0 !important;
}
.main-banner .hero-stat-value {
  font-family: var(--font-serif) !important;
  font-weight: 400 !important;
  font-size: 2.25rem !important;
  line-height: 1 !important;
  color: var(--ink-900) !important;
  letter-spacing: -0.02em !important;
  margin-bottom: 6px !important;
}
.main-banner .hero-stat-label {
  font-family: var(--font-sans) !important;
  font-size: 11px !important;
  letter-spacing: 0.12em !important;
  text-transform: uppercase !important;
  color: var(--ink-500) !important;
  font-weight: 600 !important;
  line-height: 1.4 !important;
}
@media (max-width: 480px) {
  .main-banner .hero-stat-value { font-size: 1.75rem !important; }
  .main-banner .hero-stats > li { padding: 0 12px !important; }
}

/* =========================================================================
   Global body & type
   ========================================================================= */

html { -webkit-text-size-adjust: 100%; }

body {
  color: var(--ink-600);
  background: var(--surface);
  font-family: var(--font-sans);
  font-weight: 500;
  font-feature-settings: "cv11", "ss01", "ss02";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  line-height: 1.6;
  font-size: var(--fs-body);
}

h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
  color: var(--ink-900);
  font-family: var(--font-display);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.3;
  margin-bottom: 0.5em;
}
h1, .h1 { font-size: var(--fs-h1); letter-spacing: -0.03em; }
h2, .h2 { font-size: var(--fs-h2); letter-spacing: -0.025em; }
h3, .h3 { font-size: var(--fs-h3); }
h4, .h4 { font-size: var(--fs-h4); }
h5, .h5 { font-size: var(--fs-h5); }

p { color: var(--ink-600); line-height: 1.65; }

h1 em, h2 em, h3 em, h4 em, .h1 em, .h2 em, .h3 em {
  font-family: var(--font-serif);
  font-weight: 400;
  font-style: italic;
  color: var(--brand-primary);
  letter-spacing: -0.02em;
}

.serif { font-family: var(--font-serif); font-weight: 400; letter-spacing: -0.01em; }
.italic-serif { font-family: var(--font-serif); font-style: italic; font-weight: 400; }

.eyebrow, .title-ext {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: var(--font-sans);
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-weight: 600;
  font-size: var(--fs-eyebrow);
  color: var(--brand-primary);
  margin-bottom: 16px;
}
.eyebrow::before, .title-ext::before {
  content: "";
  width: 28px;
  height: 1.5px;
  background: currentColor;
  border-radius: 2px;
}
.title-ext.text-secondary,
.eyebrow.text-secondary { color: var(--brand-secondary) !important; }

.lede {
  font-size: var(--fs-body-lg);
  color: var(--ink-500);
  line-height: 1.7;
  max-width: 62ch;
}

/* Focus */
:focus { outline: none; }
:focus-visible {
  outline: 2px solid var(--brand-primary);
  outline-offset: 3px;
  border-radius: 6px;
}
a { color: var(--brand-primary); text-decoration: none; transition: color var(--dur) var(--ease-out); }
a:hover { color: var(--brand-primary-hover); }
a, button, [role="button"] {
  transition: color var(--dur) var(--ease-out),
              background-color var(--dur) var(--ease-out),
              box-shadow var(--dur) var(--ease-out),
              border-color var(--dur) var(--ease-out),
              transform var(--dur) var(--ease-out);
}

/* =========================================================================
   Container + section rhythm
   ========================================================================= */

.container {
  padding-left: var(--container-pad) !important;
  padding-right: var(--container-pad) !important;
  margin-left: auto !important;
  margin-right: auto !important;
  width: 100% !important;
  box-sizing: border-box !important;
}
.container-fluid {
  padding-left: var(--container-pad);
  padding-right: var(--container-pad);
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}
@media (min-width: 576px)  { .container { max-width: 540px !important; } }
@media (min-width: 768px)  { .container { max-width: 720px !important; } }
@media (min-width: 992px)  { .container { max-width: 960px !important; } }
@media (min-width: 1200px) { .container { max-width: 1200px !important; } }
@media (min-width: 1400px) { .container { max-width: 1360px !important; } }
@media (min-width: 1600px) { .container { max-width: 1440px !important; } }

section, .section-area { position: relative; }
.section-sp1, .section-sp2, .section-sp3, .section-sp {
  padding-top: 72px;
  padding-bottom: 72px;
}
@media (min-width: 992px) {
  .section-sp1, .section-sp2, .section-sp3, .section-sp {
    padding-top: 120px;
    padding-bottom: 120px;
  }
}
.section-tint { background: var(--surface-2); }
/* Two tinted sections back-to-back read as one band — collapse the doubled padding
   between them so it doesn't look like an empty gap floating inside a single color. */
.section-tint + .section-tint {
  padding-top: 56px !important;
}
.section-brand-soft { background: var(--grad-brand-soft); }

/* Home + About + Medicine + Blog + Quality + Contact pages — every section
   on these pages carried the same 120px desktop / 72px mobile padding as
   the rest of the site, which read as a lot of dead space stacked between
   short-content sections. Tighten just these pages rather than the shared
   default other pages still rely on. */
.home-page .section-sp1, .home-page .section-sp2, .home-page .section-sp3, .home-page .section-sp,
.about-page .section-sp1, .about-page .section-sp2, .about-page .section-sp3, .about-page .section-sp,
.medicine-page .section-sp1, .medicine-page .section-sp2, .medicine-page .section-sp3, .medicine-page .section-sp,
.blog-page .section-sp1, .blog-page .section-sp2, .blog-page .section-sp3, .blog-page .section-sp,
.quality-page .section-sp1, .quality-page .section-sp2, .quality-page .section-sp3, .quality-page .section-sp,
.contact-page .section-sp1, .contact-page .section-sp2, .contact-page .section-sp3, .contact-page .section-sp {
  padding-top: 48px;
  padding-bottom: 48px;
}
@media (min-width: 992px) {
  .home-page .section-sp1, .home-page .section-sp2, .home-page .section-sp3, .home-page .section-sp,
  .about-page .section-sp1, .about-page .section-sp2, .about-page .section-sp3, .about-page .section-sp,
  .medicine-page .section-sp1, .medicine-page .section-sp2, .medicine-page .section-sp3, .medicine-page .section-sp,
  .blog-page .section-sp1, .blog-page .section-sp2, .blog-page .section-sp3, .blog-page .section-sp,
  .quality-page .section-sp1, .quality-page .section-sp2, .quality-page .section-sp3, .quality-page .section-sp,
  .contact-page .section-sp1, .contact-page .section-sp2, .contact-page .section-sp3, .contact-page .section-sp {
    padding-top: 72px;
    padding-bottom: 72px;
  }
}
.home-page .section-tint + .section-tint,
.about-page .section-tint + .section-tint,
.medicine-page .section-tint + .section-tint,
.blog-page .section-tint + .section-tint,
.quality-page .section-tint + .section-tint,
.contact-page .section-tint + .section-tint {
  padding-top: 32px !important;
}
.home-page .about-area {
  padding: 56px 0 !important;
}

/* =========================================================================
   Header — permanently fixed to the viewport top, driven entirely by our
   own \`stuck\` React state (see header.jsx). This used to run through
   react-stickynode, a legacy library that tracked scroll position with its
   own independent, separately-throttled state machine — parallel to (and
   sometimes briefly out of sync with) our own scroll listener. The template
   also had its own CSS rule making \`.menu-bar\` fix itself whenever
   react-stickynode's \`.active\` class appeared, a SECOND independent
   fixed-position layer on top of react-stickynode's JS-driven one. Two
   independently-updating fixed layers occasionally disagreeing mid-scroll
   is what caused the header to visibly hang onto a white background for a
   moment after scrolling back to the top. Removing react-stickynode
   removes that whole class of bug — position is now driven by exactly one
   state, ours, always in sync with the background/shadow it pairs with.
   \`#main-content\` carries matching top padding so page content isn't
   hidden under the now-permanently-fixed bar (see further down). */

.header,
.header.header-transparent,
.header.rs-nav {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  z-index: 1030 !important;
  background: transparent !important;
  /* Force the fixed header onto its own stable GPU compositing layer,
     isolated from the scrolling page content underneath. Without this,
     some browser/GPU combinations can blend a fixed element with fast-
     moving content behind it for a frame or two during a fast scroll —
     visible as page content "ghosting" through the header — even though
     nothing in our own CSS produces that state. This is the standard,
     defensive fix for that class of compositing artifact. */
  transform: translateZ(0);
  will-change: transform;
}
.header .sticky-header {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

/* The visible header band is .menu-bar — style it (bg + shadow + transition).
   At top: fully transparent, no tint at all, so it's unambiguous. On scroll:
   solid white with a shadow. */
.menu-bar,
.header-transparent .menu-bar,
.header .menu-bar,
.rs-nav .menu-bar {
  position: static !important;
  background: transparent !important;
  backdrop-filter: none !important;
  padding: 0 !important;
  width: 100% !important;
  height: auto !important;
  border-bottom: 1px solid transparent !important;
  box-shadow: none !important;
  z-index: 1030 !important;
  /* No transition, on purpose: a fade between transparent and solid white
     means there's a window where background-color is some intermediate
     rgba(255,255,255,X) — genuinely translucent, with page content visibly
     showing through the nav bar. Caught on video/screenshot that reads as
     a rendering glitch, not a nice fade. Snapping instantly means there is
     never a partial state to see. */
  transition: none !important;
}
/* Fully transparent at top over the hero; solid white with shadow when scrolled */
.header.is-stuck .menu-bar,
.rs-nav.is-stuck .menu-bar {
  background: #ffffff !important;
  border-bottom-color: var(--ink-200) !important;
  box-shadow: 0 6px 24px rgba(11, 37, 54, 0.08) !important;
}
/* Menu bar is a relatively-positioned strip. Logo + CTA float left/right,
   nav is absolutely centered to the viewport so it's dead-center regardless
   of logo or CTA widths. */
.menu-bar > .container-fluid {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  position: relative !important;
  gap: 24px !important;
  height: 96px !important;
  padding-left: 32px !important;
  padding-right: 32px !important;
  transition: height var(--dur) var(--ease-out) !important;
}
@media (min-width: 1200px) {
  .menu-bar > .container-fluid {
    padding-left: 48px !important;
    padding-right: 48px !important;
  }
}
/* Compact bar when scrolled */
.header.is-stuck .menu-bar > .container-fluid {
  height: 72px !important;
}
/* The header is always position:fixed now (see above), so it's out of
   normal document flow — reserve the same space it used to occupy in-flow
   at the top of the page, using its unstuck (tallest) height. Once the
   user scrolls, the header overlapping page content is expected sticky-
   header behaviour, not something to compensate for. */
#main-content { padding-top: 96px; }
@media (max-width: 767px) {
  #main-content { padding-top: 72px; }
}

/* Logo — bigger by default, shrinks on scroll. Absolutely pinned to LEFT. */
.header .menu-logo,
.rs-nav .menu-logo {
  display: inline-flex !important;
  align-items: center !important;
  float: none !important;
  padding: 0 !important;
  margin: 0 !important;
  width: auto !important;
  height: auto !important;
  min-width: 0 !important;
  z-index: 2 !important;
}
@media (min-width: 1200px) {
  .header .menu-logo,
  .rs-nav .menu-logo {
    position: absolute !important;
    left: 48px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
  }
}
.header .menu-logo a,
.rs-nav .menu-logo a {
  display: inline-flex !important;
  align-items: center !important;
  padding: 0 !important;
  line-height: 0 !important;
}
.header .menu-logo img,
.rs-nav .menu-logo img {
  width: auto !important;
  height: 56px !important;
  max-height: 56px !important;
  display: block !important;
  transition: height var(--dur) var(--ease-out) !important;
}
.header.is-stuck .menu-logo img,
.rs-nav.is-stuck .menu-logo img {
  height: 40px !important;
  max-height: 40px !important;
}

/* Kill template secondary-menu 105px height. Absolutely pinned to RIGHT. */
.header .secondary-menu,
.rs-nav .secondary-menu {
  float: none !important;
  height: auto !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  z-index: 2 !important;
}
@media (min-width: 1200px) {
  .header .secondary-menu,
  .rs-nav .secondary-menu {
    position: absolute !important;
    right: 48px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
  }
}
.header .secondary-menu > ul,
.rs-nav .secondary-menu > ul {
  margin: 0 !important;
  padding: 0 !important;
  list-style: none !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 12px !important;
}

/* Menu links wrapper — absolutely centered to viewport, ignores flex flow */
@media (min-width: 1200px) {
  .header .menu-links,
  .rs-nav .menu-links {
    position: absolute !important;
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%) !important;
    padding: 0 !important;
    margin: 0 !important;
    height: auto !important;
    min-width: 0 !important;
    float: none !important;
    z-index: 1 !important;
  }
}
.header .navbar-toggler,
.rs-nav .navbar-toggler {
  order: 4 !important;
}

/* Nav list — reset template float:right + margin-right:50px, then center */
.header .menu-links .nav,
.rs-nav .menu-links .nav {
  float: none !important;
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px !important;
  list-style: none !important;
}
.header .menu-links .nav > li,
.rs-nav .menu-links .nav > li {
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  float: none !important;
  width: auto !important;
}

/* Nav LINKS — kill template's 45px top/bottom padding */
.header .menu-links .nav > li > a,
.rs-nav .menu-links .nav > li > a,
.nav.navbar-nav li a {
  font-family: var(--font-sans) !important;
  font-weight: 500 !important;
  font-size: 14.5px !important;
  color: var(--ink-800) !important;
  letter-spacing: -0.005em !important;
  padding: 10px 14px !important;
  border-radius: var(--radius-pill) !important;
  white-space: nowrap !important;
  line-height: 1.2 !important;
  border: none !important;
  display: inline-block !important;
  cursor: pointer;
  transition: background var(--dur) var(--ease-out), color var(--dur) var(--ease-out) !important;
}
.header .menu-links .nav > li > a:hover,
.rs-nav .menu-links .nav > li > a:hover,
.nav.navbar-nav li a:hover {
  color: var(--brand-primary) !important;
  background: var(--brand-primary-soft) !important;
}
.header .menu-links .nav > li.active > a,
.rs-nav .menu-links .nav > li.active > a,
.nav.navbar-nav li.active > a {
  color: var(--brand-primary) !important;
  background: var(--brand-primary-soft) !important;
}
.secondary-menu .btn { font-size: 13.5px !important; padding: 10px 20px !important; }

/* Drawer on < xl */
@media (max-width: 1199.98px) {
  .header .menu-bar .navbar-toggler,
  .rs-nav .menu-bar .navbar-toggler { display: inline-flex !important; }
  .header .secondary-menu,
  .rs-nav .secondary-menu { display: none !important; }
  .header #menuDropdown,
  .rs-nav #menuDropdown {
    display: none !important;
    opacity: 0;
    visibility: hidden;
  }
  .header #menuDropdown.show,
  .rs-nav #menuDropdown.show {
    display: flex !important;
    opacity: 1;
    visibility: visible;
    position: fixed !important;
    inset: 0 !important;
    z-index: 1050 !important;
    background: var(--surface) !important;
    padding: 24px !important;
    flex-direction: column !important;
    align-items: stretch !important;
    justify-content: flex-start !important;
    overflow-y: auto !important;
    width: 100% !important;
    height: 100vh !important;
    max-width: none !important;
  }
  #menuDropdown.show .nav.navbar-nav {
    flex-direction: column !important;
    gap: 6px !important;
    width: 100% !important;
    padding: 40px 0 !important;
    align-items: stretch !important;
  }
  #menuDropdown.show .nav.navbar-nav li {
    width: 100% !important;
    display: block !important;
  }
  #menuDropdown.show .nav.navbar-nav li a {
    display: block !important;
    padding: 16px 20px !important;
    font-size: 17px !important;
    border-radius: 12px !important;
    color: var(--ink-900) !important;
    background: transparent !important;
  }
  #menuDropdown.show .nav.navbar-nav li a:hover {
    background: var(--brand-primary-soft) !important;
    color: var(--brand-primary) !important;
  }
  #menuDropdown.show .menu-logo {
    display: block !important;
    padding: 0 0 20px 0 !important;
    border-bottom: 1px solid var(--ink-200) !important;
  }
  #menuDropdown.show .menu-close {
    display: inline-flex !important;
    position: absolute !important;
    top: 28px !important;
    right: 28px !important;
    color: var(--ink-900) !important;
    background: var(--surface);
    border: 1px solid var(--ink-200);
    border-radius: 12px;
    width: 44px;
    height: 44px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
@media (min-width: 1200px) {
  .header .navbar-toggler,
  .rs-nav .navbar-toggler { display: none !important; }
  .menu-links .menu-logo,
  .menu-links .menu-close { display: none !important; }
}

/* =========================================================================
   Page hero / inner banners
   ========================================================================= */

.page-banner {
  padding: 36px 0 20px !important;
  background:
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}),
    var(--grad-hero-bg) !important;
  background-repeat: repeat, no-repeat !important;
  background-position: center, center !important;
  background-size: 28px 28px, cover !important;
  position: relative !important;
  overflow: hidden !important;
  height: auto !important;
  min-height: 0 !important;
  display: block !important;
}
.page-banner::before,
.page-banner::after { content: none !important; display: none !important; }
.page-banner .page-banner-entry {
  position: relative;
  z-index: 2;
}
.page-banner-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--surface);
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-pill);
  padding: 4px 12px;
  margin-bottom: 8px;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--brand-primary);
  box-shadow: var(--shadow-xs);
}
.page-banner h1, .page-banner .h1 {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: clamp(1.625rem, 1.8vw + 1rem, 2.5rem);
  color: var(--ink-900);
  letter-spacing: -0.03em;
  margin-bottom: 6px;
  text-transform: none !important;
}
.page-banner h1 em {
  font-family: var(--font-serif);
  font-style: italic;
  font-weight: 400;
  color: var(--brand-primary);
}
.page-banner-lede {
  max-width: 560px;
  margin: 0 auto 12px;
  color: var(--ink-600);
  font-size: 1rem;
  line-height: 1.5;
}
.page-banner .breadcrumb {
  display: inline-flex;
  gap: 6px;
  padding: 5px 12px;
  background: var(--surface);
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-pill);
  box-shadow: var(--shadow-xs);
  margin: 0 auto;
  list-style: none;
}
.page-banner .breadcrumb li,
.page-banner .breadcrumb-item {
  font-size: 13px;
  font-weight: 500;
  color: var(--ink-500);
}
.page-banner .breadcrumb-item.active { color: var(--brand-primary); }
.page-banner .breadcrumb-item + .breadcrumb-item::before {
  content: "/" !important;
  color: var(--ink-300);
  padding: 0 6px;
}
.page-banner .breadcrumb a { color: var(--ink-700); }
.page-banner .breadcrumb a:hover { color: var(--brand-primary); }
.page-banner .pt-img1,
.page-banner .pt-img2,
.page-banner .pt-img3,
.page-banner .pt-img4,
.page-banner .pt-img5 { opacity: 0.25; }

/* =========================================================================
   Buttons
   ========================================================================= */

.btn {
  --btn-py: 12px;
  --btn-px: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: var(--btn-py) var(--btn-px);
  border-radius: var(--radius-pill);
  font-family: var(--font-sans);
  font-weight: 600;
  font-size: 14.5px;
  letter-spacing: -0.005em;
  line-height: 1.2;
  border: 1.5px solid transparent;
  cursor: pointer;
  will-change: transform;
}
.btn-sm { --btn-py: 8px; --btn-px: 16px; font-size: 13px; }
.btn-lg { --btn-py: 15px; --btn-px: 28px; font-size: 15.5px; }

.btn-primary,
.btn-primary.shadow {
  background: var(--brand-primary) !important;
  border-color: var(--brand-primary) !important;
  color: #fff !important;
  box-shadow: var(--shadow-cta) !important;
}
.btn-primary:hover,
.btn-primary:focus-visible {
  background: var(--brand-primary-hover) !important;
  border-color: var(--brand-primary-hover) !important;
  color: #fff !important;
  box-shadow: var(--shadow-cta-hover) !important;
  transform: translateY(-1px);
}
.btn-primary:active {
  background: var(--brand-primary-pressed) !important;
  transform: translateY(0);
}
.btn-primary.light {
  background: var(--brand-primary-soft) !important;
  color: var(--brand-primary) !important;
  border-color: transparent !important;
  box-shadow: none !important;
}
.btn-primary .btn-icon-bx { color: currentColor; }

.btn-secondary,
.btn-secondary.shadow {
  background: var(--brand-secondary) !important;
  border-color: var(--brand-secondary) !important;
  color: #fff !important;
  box-shadow: var(--shadow-cta-secondary) !important;
}
.btn-secondary:hover,
.btn-secondary:focus-visible {
  background: var(--brand-secondary-hover) !important;
  border-color: var(--brand-secondary-hover) !important;
  color: #fff !important;
  transform: translateY(-1px);
}
.btn-secondary.light {
  background: var(--brand-secondary-soft) !important;
  color: var(--brand-secondary) !important;
  border-color: transparent !important;
  box-shadow: none !important;
}
.btn-outline-primary {
  background: transparent !important;
  border: 1.5px solid var(--ink-200) !important;
  color: var(--ink-900) !important;
  box-shadow: none !important;
}
.btn-outline-primary:hover,
.btn-outline-primary:focus-visible {
  background: var(--ink-900) !important;
  border-color: var(--ink-900) !important;
  color: #fff !important;
  transform: translateY(-1px);
}
.btn .arrow-i { transition: transform var(--dur) var(--ease-out); }
.btn:hover .arrow-i { transform: translateX(3px); }

.text-primary { color: var(--brand-primary) !important; }
.text-secondary { color: var(--brand-secondary) !important; }
.bg-primary { background: var(--brand-primary) !important; }
.bg-secondary { background: var(--brand-secondary) !important; }
.bg-dark { background: var(--brand-dark) !important; }

/* =========================================================================
   Cards
   ========================================================================= */

.card,
.blog-card,
.medicine-card,
.distributor-card,
.premium-card {
  background: var(--surface);
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  transition: box-shadow var(--dur) var(--ease-out),
              transform var(--dur) var(--ease-out),
              border-color var(--dur) var(--ease-out);
}
.card:hover,
.blog-card:hover,
.medicine-card:hover,
.distributor-card:hover,
.premium-card:hover {
  box-shadow: var(--shadow-md);
  border-color: var(--ink-300);
  transform: translateY(-3px);
}

/* Become-a-distributor "Eligibility / Onboarding" split — plain content on
   the tinted section background instead of two matching boxed cards, with a
   vertical hairline divider and a connecting line through the step numbers. */
.onboarding-divider {
  width: 1px;
  height: 100%;
  min-height: 280px;
  background: var(--ink-200);
}
.onboarding-timeline > li { position: relative; padding-bottom: 28px; }
.onboarding-timeline > li:last-child { padding-bottom: 0; }
.onboarding-timeline > li::before {
  content: "";
  position: absolute;
  left: 21px;
  top: 44px;
  bottom: 0;
  width: 2px;
  background: var(--ink-200);
}
.onboarding-timeline > li:last-child::before { content: none; }
.onboarding-node { position: relative; z-index: 1; }

/* About page — Mission / Vision split (plain text either side of a hairline,
   not two boxed cards) and the Values spec-grid (bordered cells, no shadow,
   no hover-lift — a quieter table treatment distinct from .therapy-card). */
.mission-vision-col { padding: 8px 0; }
.mission-vision-num {
  display: block;
  font-size: 2rem;
  line-height: 1;
  color: var(--ink-300);
  margin-bottom: 12px;
}
@media (min-width: 992px) {
  .mission-vision-col.is-start { padding-right: 48px; }
  .mission-vision-col.is-end { padding-left: 48px; }
}

.value-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  border-top: 1px solid var(--ink-200);
  border-left: 1px solid var(--ink-200);
  border-radius: var(--radius-lg);
  overflow: hidden;
}
.value-grid-item {
  padding: 32px;
  border-right: 1px solid var(--ink-200);
  border-bottom: 1px solid var(--ink-200);
  display: flex;
  gap: 16px;
  align-items: flex-start;
}
.value-grid-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: var(--brand-primary-soft);
  color: var(--brand-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.value-grid-item h3 { font-size: 17px; margin-bottom: 6px; letter-spacing: -0.01em; }
.value-grid-item p { margin: 0; color: var(--ink-500); font-size: 14.5px; line-height: 1.6; }
@media (max-width: 767px) {
  .value-grid { grid-template-columns: 1fr; }
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: var(--radius-pill);
  background: var(--brand-primary-soft);
  color: var(--brand-primary);
  font-size: 13px;
  font-weight: 600;
}
.chip-outline {
  background: transparent;
  border: 1px solid var(--ink-200);
  color: var(--ink-700);
}
.chip-warm { background: var(--brand-secondary-soft); color: var(--brand-secondary); }

/* =========================================================================
   Trust strip
   ========================================================================= */

.trust-strip {
  padding: 28px 0;
  background: var(--surface);
  border-top: 1px solid var(--ink-200);
  border-bottom: 1px solid var(--ink-200);
}
.trust-strip .trust-item {
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--ink-700);
  font-weight: 600;
  font-size: 14px;
  padding: 6px 0;
}
.trust-strip .trust-icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 12px;
  background: var(--brand-primary-soft);
  color: var(--brand-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* =========================================================================
   Section header
   ========================================================================= */

.section-head { text-align: center; margin-bottom: 56px; }
.section-head.left { text-align: left; margin-bottom: 40px; }
.section-head h2, .section-head .section-head-title {
  margin: 0 0 12px;
  font-family: var(--font-display);
  font-weight: 700;
  letter-spacing: -0.025em;
}
.section-head .lede { margin: 0 auto; }
.section-head.left .lede { margin: 0; }

/* =========================================================================
   Therapy / value cards
   ========================================================================= */

.therapy-grid .therapy-card {
  position: relative;
  padding: 28px;
  background: var(--surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--ink-200);
  height: 100%;
  display: block;
  color: inherit;
  overflow: hidden;
  transition: transform var(--dur) var(--ease-out),
              box-shadow var(--dur) var(--ease-out),
              border-color var(--dur) var(--ease-out);
  text-decoration: none;
}
.therapy-grid .therapy-card::after {
  content: "";
  position: absolute;
  inset: auto -30% -60% auto;
  width: 220px;
  height: 220px;
  background: var(--grad-brand);
  opacity: 0;
  border-radius: 50%;
  filter: blur(40px);
  transition: opacity var(--dur) var(--ease-out);
  pointer-events: none;
  z-index: 0;
}
.therapy-grid .therapy-card:hover {
  border-color: transparent;
  box-shadow: var(--shadow-lg);
  transform: translateY(-6px);
}
.therapy-grid .therapy-card:hover::after { opacity: 0.10; }
.therapy-grid .therapy-card > * { position: relative; z-index: 1; }

.therapy-grid .therapy-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: var(--brand-primary-soft);
  color: var(--brand-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  transition: background var(--dur) var(--ease-out), color var(--dur) var(--ease-out);
}
.therapy-grid .therapy-card:hover .therapy-icon {
  background: var(--brand-primary);
  color: #fff;
}
.therapy-grid .therapy-icon svg { width: 24px; height: 24px; }
.therapy-grid .therapy-card h3 {
  font-size: 19px;
  margin-bottom: 8px;
  letter-spacing: -0.01em;
  color: var(--ink-900);
}
.therapy-grid .therapy-card p { color: var(--ink-500); margin: 0; font-size: 14.5px; line-height: 1.6; }
.therapy-grid .therapy-card .card-arrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 16px;
  color: var(--brand-primary);
  font-weight: 600;
  font-size: 13.5px;
  opacity: 0;
  transform: translateY(4px);
  transition: opacity var(--dur) var(--ease-out), transform var(--dur) var(--ease-out);
}
.therapy-grid .therapy-card:hover .card-arrow {
  opacity: 1;
  transform: translateY(0);
}

/* =========================================================================
   Quality checklist — enumerated rows, not cards. Large faded index number,
   icon, copy; divided by hairlines. Used on the Quality page's "six checks"
   so it doesn't repeat the card-grid pattern already used elsewhere.
   ========================================================================= */
.quality-checklist {
  list-style: none;
  margin: 0;
  padding: 0;
  max-width: 900px;
  margin-inline: auto;
}
.quality-checklist > li {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  padding: 28px 0;
  border-bottom: 1px solid var(--ink-200);
}
.quality-checklist > li:first-child { padding-top: 0; }
.quality-checklist > li:last-child { border-bottom: none; padding-bottom: 0; }
.quality-checklist-num {
  font-family: var(--font-serif);
  font-size: 2rem;
  line-height: 1;
  color: var(--ink-300);
  flex-shrink: 0;
  width: 56px;
  padding-top: 4px;
}
.quality-checklist-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: var(--brand-primary-soft);
  color: var(--brand-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.quality-checklist-copy h3 { font-size: 18px; margin-bottom: 6px; letter-spacing: -0.01em; }
.quality-checklist-copy p { color: var(--ink-500); margin: 0; font-size: 14.5px; line-height: 1.6; }
@media (max-width: 575px) {
  .quality-checklist > li { gap: 14px; }
  .quality-checklist-num { width: 34px; font-size: 1.5rem; }
}

/* =========================================================================
   Therapeutic areas — anchor stat panel + adjacent-areas list (rows, not
   another card grid, since the quick-grid cards already live on the Home
   page teaser).
   ========================================================================= */
#cardiology { scroll-margin-top: 96px; }
.area-stat-panel {
  height: 100%;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px;
  border-radius: var(--radius-xl);
  background: var(--grad-brand-soft);
  box-shadow: var(--shadow-md);
}
.area-stat-icon {
  width: 76px;
  height: 76px;
  border-radius: 20px;
  background: var(--surface);
  color: var(--brand-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  box-shadow: var(--shadow-sm);
}
.area-stat-value {
  font-family: var(--font-serif);
  font-size: 44px;
  color: var(--brand-primary);
  line-height: 1;
}
.area-stat-panel p {
  margin: 10px 0 0;
  color: var(--ink-600);
  max-width: 280px;
}

.area-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.area-list > li {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  padding: 32px 0;
  border-bottom: 1px solid var(--ink-200);
  scroll-margin-top: 96px;
}
.area-list > li:first-child { padding-top: 0; }
.area-list > li:last-child { border-bottom: none; padding-bottom: 0; }
.area-list-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: var(--brand-primary-soft);
  color: var(--brand-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.area-list-copy h3 { font-size: 19px; margin-bottom: 6px; letter-spacing: -0.01em; }
.area-list-copy p { color: var(--ink-500); margin: 0 0 14px; font-size: 14.5px; line-height: 1.6; }
@media (max-width: 575px) {
  .area-list > li { gap: 14px; }
  .area-list-icon { width: 42px; height: 42px; }
}

/* =========================================================================
   Stats strip
   ========================================================================= */

.stats-strip {
  background: linear-gradient(135deg, var(--brand-dark) 0%, var(--brand-dark-2) 100%);
  color: #fff;
  padding: 72px 0;
  position: relative;
  overflow: hidden;
}
.stats-strip::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(600px 400px at 90% 10%, rgba(0, 168, 212, 0.20), transparent 60%),
    radial-gradient(500px 300px at 10% 90%, rgba(241, 119, 50, 0.14), transparent 60%);
  pointer-events: none;
}
.stats-strip .container { position: relative; z-index: 1; }
.stats-strip .stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 0; }
@media (max-width: 767px) { .stats-strip .stats-grid { grid-template-columns: repeat(2, 1fr); } }
.stats-strip .stat { text-align: center; padding: 24px 12px; position: relative; }
.stats-strip .stat + .stat::before {
  content: "";
  position: absolute;
  top: 20%;
  bottom: 20%;
  left: 0;
  width: 1px;
  background: rgba(255, 255, 255, 0.12);
}
@media (max-width: 767px) {
  .stats-strip .stat:nth-child(odd) + .stat::before { display: none; }
}
.stats-strip .stat-value {
  font-family: var(--font-serif);
  font-weight: 400;
  font-size: clamp(2.5rem, 3.5vw, 3.5rem);
  line-height: 1;
  color: #fff;
  letter-spacing: -0.025em;
  margin-bottom: 12px;
}
.stats-strip .stat-value .unit {
  font-family: var(--font-sans);
  font-size: 0.4em;
  vertical-align: super;
  color: var(--brand-primary);
  margin-left: 4px;
  letter-spacing: 0;
  font-weight: 600;
}
.stats-strip .stat-label {
  color: rgba(255, 255, 255, 0.70);
  font-size: 12px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  font-weight: 600;
}

/* =========================================================================
   Pre-footer CTA
   ========================================================================= */

.prefooter-cta {
  position: relative;
  background: linear-gradient(135deg, var(--brand-primary) 0%, var(--brand-primary-pressed) 100%);
  color: #fff;
  padding: 72px 40px;
  border-radius: var(--radius-2xl);
  margin: 96px 24px;
  overflow: hidden;
  box-shadow: var(--shadow-lg);
}
.prefooter-cta::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(400px 300px at 100% 0%, rgba(255, 255, 255, 0.14), transparent 60%),
    radial-gradient(400px 300px at 0% 100%, rgba(0, 0, 0, 0.15), transparent 60%);
  pointer-events: none;
}
.prefooter-cta .prefooter-inner { position: relative; z-index: 1; }
.prefooter-cta h2 {
  color: #fff;
  font-family: var(--font-display);
  font-size: var(--fs-h2);
  letter-spacing: -0.025em;
}
.prefooter-cta h2 em {
  font-family: var(--font-serif);
  font-style: italic;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.85);
}
.prefooter-cta p { color: rgba(255, 255, 255, 0.86); font-size: 1.0625rem; }
.prefooter-cta .btn-primary {
  background: #fff !important;
  color: var(--brand-primary) !important;
  border-color: #fff !important;
  box-shadow: var(--shadow-md) !important;
}
.prefooter-cta .btn-primary:hover {
  background: #F4FAFC !important;
  color: var(--brand-primary-pressed) !important;
}
.prefooter-cta .btn-outline-primary {
  border-color: rgba(255, 255, 255, 0.5) !important;
  color: #fff !important;
  background: transparent !important;
}
.prefooter-cta .btn-outline-primary:hover {
  background: #fff !important;
  color: var(--brand-primary) !important;
  border-color: #fff !important;
}

/* =========================================================================
   Testimonial
   ========================================================================= */

.testimonial-wraper .heading-bx h2 {
  font-family: var(--font-display);
  font-size: var(--fs-h1);
  margin-bottom: 8px;
}
.testimonial-wraper .heading-bx h2 br { display: none; }
.testimonial-bx {
  position: relative;
  background: var(--surface);
  border-radius: var(--radius-xl);
  padding: 44px 40px;
  border: 1px solid var(--ink-200);
  box-shadow: var(--shadow-md);
}
.testimonial-bx .quote-icon {
  position: absolute;
  top: -14px;
  left: 32px;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: var(--brand-primary);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-cta);
}
.testimonial-bx .testimonial-content p {
  font-family: var(--font-serif);
  font-size: 1.35rem;
  line-height: 1.5;
  color: var(--ink-900);
  letter-spacing: -0.01em;
  font-style: italic;
  font-weight: 400;
  margin-bottom: 24px;
}
.testimonial-bx .client-info .name {
  color: var(--ink-900);
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 1.0625rem;
  margin-bottom: 2px;
}
.testimonial-bx .client-info p {
  color: var(--ink-500);
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.10em;
  font-weight: 600;
  margin: 0;
}
.testimonial-wraper .thumb-wraper {
  position: relative;
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.testimonial-wraper .thumb-wraper .overlay-image {
  width: 180px !important;
  height: 180px !important;
  box-shadow: var(--shadow-lg) !important;
  border: 4px solid #fff !important;
}
.testimonial-wraper .thumb-wraper .bg-img { opacity: 0.35; }
.testimonial-wraper .thumb-wraper ul { padding-left: 0; list-style: none; }

/* Single unified testimonial card — full container width like every other
   card on the page, split internally into quote (left) + attribution (right)
   with a divider, so it doesn't read as an undersized orphan block. */
.testimonial-single-wrap {
  width: 100%;
}
.testimonial-bx-unified {
  /* The template's base .testimonial-bx (still applied alongside this class,
     see testimonial.jsx) hardcodes height: 303px / min-height: 302px for
     its own shorter single-line quote design. Our unified card holds a
     longer quote plus a client-info row — on mobile, where both stack
     vertically, that easily exceeds 303px and the info row was rendering
     outside the card's own background. Let it size to its content. */
  height: auto !important;
  min-height: 0 !important;
  display: flex;
  align-items: stretch;
  gap: 48px;
  padding: 48px;
  text-align: left;
}
.testimonial-bx-unified .testimonial-main {
  flex: 1 1 auto;
  min-width: 0;
}
.testimonial-bx-unified .quote-icon {
  position: static;
  margin-bottom: 20px;
}
.testimonial-bx-unified .testimonial-content p {
  font-size: 1.5rem;
}
.testimonial-bx-unified .client-info-col {
  flex: 0 0 240px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 14px;
  padding-left: 48px;
  border-left: 1px solid var(--ink-200);
}
.testimonial-bx-unified .client-avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--brand-primary-soft);
  flex-shrink: 0;
}
.testimonial-dots button {
  width: 44px;
  height: 44px;
  padding: 0;
  border-radius: 50%;
  border: 2px solid transparent;
  background: transparent;
  cursor: pointer;
  transition: border-color var(--dur) var(--ease-out);
}
.testimonial-dots button.is-active { border-color: var(--brand-primary); }
.testimonial-dots button img {
  width: 36px;
  height: 36px;
  object-fit: cover;
  border-radius: 50%;
  display: block;
  margin: 0 auto;
}
@media (max-width: 767px) {
  .testimonial-bx-unified {
    flex-direction: column;
    padding: 32px 24px;
    gap: 24px;
  }
  .testimonial-bx-unified .testimonial-content p { font-size: 1.25rem; }
  .testimonial-bx-unified .client-info-col {
    /* Base rule's \`flex: 0 0 240px\` sets WIDTH in the desktop row layout,
       but .testimonial-bx-unified switches to flex-direction: column here —
       that same flex-basis then forces a 240px HEIGHT instead, well past
       what the avatar+name actually need, overflowing the card and getting
       clipped. Reset to content-sized. */
    flex: 0 0 auto;
    flex-direction: row;
    align-items: center;
    border-left: none;
    border-top: 1px solid var(--ink-200);
    padding-left: 0;
    padding-top: 24px;
    width: 100%;
  }
}

/* =========================================================================
   Blog cards
   ========================================================================= */

.blog-card {
  display: flex;
  flex-direction: column;
  border-radius: var(--radius-lg);
  overflow: hidden;
  background: var(--surface);
  border: 1px solid var(--ink-200);
  box-shadow: none;
  transition: box-shadow var(--dur) var(--ease-out), transform var(--dur) var(--ease-out), border-color var(--dur) var(--ease-out);
}
.blog-card:hover { box-shadow: var(--shadow-md); border-color: var(--ink-300); transform: translateY(-3px); }
.blog-card .post-media {
  aspect-ratio: 16 / 10;
  overflow: hidden;
  background: var(--ink-100);
}
.blog-card .post-media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform var(--dur-slow) var(--ease-out);
}
.blog-card:hover .post-media img { transform: scale(1.05); }
.blog-card .post-info,
.blog-card .info-bx { padding: 24px; }
.blog-card .post-meta {
  list-style: none;
  padding: 0;
  margin: 0 0 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
  color: var(--ink-500);
  font-size: 13px;
}
.blog-card .post-meta li { display: inline-flex; align-items: center; gap: 6px; }
.blog-card .post-title,
.blog-card h3.post-title {
  font-family: var(--font-display);
  font-size: 19px;
  margin-bottom: 16px;
  color: var(--ink-900);
  font-weight: 700;
  letter-spacing: -0.015em;
  line-height: 1.25;
}
.blog-card a.btn { align-self: flex-start; }

/* Blog detail */
.blog-detail-card {
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-xl);
  overflow: hidden;
  background: var(--surface);
}
.blog-detail-card .post-media img { width: 100%; height: auto; }
.blog-detail-card .info-bx { padding: 40px; }
.blog-detail-card .post-title { font-size: var(--fs-h2); }
.blog-detail-card p { font-size: 1.0625rem; line-height: 1.75; }

.share-row {
  display: flex; align-items: center; gap: 10px;
  margin: 32px 0 0; flex-wrap: wrap;
  padding-top: 24px;
  border-top: 1px solid var(--ink-200);
}
.share-row .share-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 8px 16px; border-radius: var(--radius-pill);
  border: 1px solid var(--ink-200);
  color: var(--ink-700);
  background: var(--surface);
  font-size: 13px; font-weight: 600;
  text-decoration: none;
}
.share-row .share-btn:hover {
  border-color: var(--brand-primary);
  color: var(--brand-primary);
  background: var(--brand-primary-soft);
}

/* =========================================================================
   Forms
   ========================================================================= */

.form-control,
.custom-select .css-13cymwt-control,
.custom-select .css-t3ipsp-control {
  border: 1.5px solid var(--ink-200) !important;
  border-radius: var(--radius-md) !important;
  min-height: 52px !important;
  padding: 12px 16px !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  color: var(--ink-800) !important;
  background: var(--surface) !important;
  font-family: var(--font-sans) !important;
}
.form-control::placeholder { color: var(--ink-400); }
.form-control:focus {
  border-color: var(--brand-primary) !important;
  box-shadow: 0 0 0 4px rgba(0, 139, 177, 0.12) !important;
  outline: none !important;
}
.form-control.error { border-color: #F72B50 !important; }
label {
  display: inline-block;
  font-family: var(--font-sans);
  font-weight: 600;
  color: var(--ink-800);
  margin-bottom: 8px;
  font-size: 13px;
  letter-spacing: -0.005em;
}
textarea.form-control { min-height: 140px !important; padding: 14px 16px !important; }

.form-wraper {
  background: var(--surface);
  padding: 32px;
  border-radius: var(--radius-xl);
  border: 1px solid var(--ink-200);
  box-shadow: var(--shadow-md);
}
.appointment-form h3, .form-wraper > h3, .form-wraper .title {
  font-family: var(--font-display);
  font-size: 22px;
  color: var(--ink-900);
  margin-bottom: 20px;
  letter-spacing: -0.015em;
}

/* =========================================================================
   Product cards & search
   ========================================================================= */

/* Template gave every .services-block-three an always-on corner-bracket accent
   in an off-brand blue (#03a9f5, not --brand-primary) via a nested div's
   ::before/::after. It shows on medicine cards, distributor cards and the
   brand filter tabs. Our own hover/active treatment on each of those already
   communicates state, so kill the leftover brackets everywhere. */
.services-block-three > div::before,
.services-block-three > div::after {
  content: none !important;
  display: none !important;
}

.product-card-design {
  padding: 24px;
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-lg);
  background: var(--surface);
  transition: all var(--dur) var(--ease-out);
  text-align: center;
}
.product-card-design:hover {
  border-color: var(--brand-primary);
  box-shadow: var(--shadow-lg);
  transform: translateY(-4px);
}
.product-card-design img {
  max-height: 180px;
  object-fit: contain;
  transition: transform var(--dur) var(--ease-out);
}
.product-card-design:hover img { transform: scale(1.03); }
.product-card-design h3 {
  font-family: var(--font-display);
  font-size: 17px;
  margin-top: 16px;
  margin-bottom: 4px;
  color: var(--ink-900);
  letter-spacing: -0.01em;
}
.product-card-design p { font-size: 13px; color: var(--ink-500); margin: 0; }

.product-searchbar {
  position: relative;
  max-width: 560px;
  margin: 0 auto 32px !important;
}
.product-searchbar input {
  width: 100%;
  height: 56px;
  border-radius: var(--radius-pill);
  background: var(--surface);
  border: 1.5px solid var(--ink-200);
  padding: 0 24px 0 52px;
  font-size: 15px;
  font-weight: 500;
  color: var(--ink-800);
  transition: all var(--dur) var(--ease-out);
  box-shadow: var(--shadow-xs);
  font-family: var(--font-sans);
}
.product-searchbar input:focus {
  outline: none;
  border-color: var(--brand-primary);
  box-shadow: 0 0 0 4px rgba(0, 139, 177, 0.10), var(--shadow-sm);
}
.product-searchbar .search-icon {
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--ink-400);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

/* Brand filter tabs — replaces the removed corner-bracket accent with a
   tinted-background active state, matching the "selected" language used
   elsewhere (header nav, chips). */
.brand-filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  gap: 20px 28px;
}
.product-tabs {
  width: auto;
  height: auto;
  cursor: pointer;
  text-align: center;
}
.product-tabs .tab-icon {
  width: 84px;
  height: 84px;
  border-radius: var(--radius-lg);
  border: 1.5px solid var(--ink-200);
  background: var(--surface);
  margin: 0 auto;
  transition: all var(--dur) var(--ease-out);
}
.product-tabs .tab-icon img { height: 36px; max-width: 60px; }
.product-tabs p {
  margin: 10px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--ink-600);
  text-transform: none !important;
  transition: color var(--dur) var(--ease-out);
}
.product-tabs:hover .tab-icon { border-color: var(--brand-primary); box-shadow: var(--shadow-sm); }
.product-tabs.active .tab-icon {
  border-color: var(--brand-primary);
  background: var(--brand-primary-soft);
  box-shadow: var(--shadow-sm);
}
.product-tabs.active p { color: var(--brand-primary); }

.medicine-results-row {
  padding: 24px 0;
  margin-bottom: 8px;
  border-top: 1px solid var(--ink-200);
  border-bottom: 1px solid var(--ink-200);
}
.medicine-results-row .text-muted { font-size: 14px; font-weight: 500; }

/* =========================================================================
   Pagination — shared by Blogs and Medicine listings. Bootstrap's default
   .pagination/.page-link had no brand styling applied anywhere, so it was
   rendering as flat, mismatched boxes.
   ========================================================================= */
.pagination {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  padding: 0;
  margin: 0;
  list-style: none;
}
.pagination .page-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  height: 44px;
  padding: 0 18px;
  border-radius: var(--radius-pill) !important;
  border: 1.5px solid var(--ink-200);
  background: var(--surface);
  color: var(--ink-700);
  font-weight: 600;
  font-size: 14px;
  transition: all var(--dur) var(--ease-out);
  cursor: pointer;
}
.pagination .page-item:first-child .page-link,
.pagination .page-item:last-child .page-link {
  width: auto !important;
}
.pagination .page-link:hover:not(:disabled) {
  border-color: var(--brand-primary);
  color: var(--brand-primary);
  background: var(--brand-primary-soft);
}
.pagination .page-link.active {
  background: var(--brand-primary);
  border-color: var(--brand-primary);
  color: #fff;
  box-shadow: var(--shadow-sm);
}
.pagination .page-item.disabled .page-link {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: none;
}

/* =========================================================================
   Medicine detail
   ========================================================================= */

.product-img-container {
  /* Template hardcodes height/min-height/max-height: 380px — a landscape
     pack-shot doesn't fill that at any width, leaving a large dead gap
     above/below the image inside the box (worst on mobile, where the
     container is also full-width and the mismatch is most visible). Let
     it hug the image + padding instead. */
  height: auto !important;
  min-height: 0 !important;
  max-height: none !important;
  background: var(--surface-2);
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-xl);
  padding: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.product-img-container img { max-height: 320px; }

/* Clinical-highlight one-pager bundled per brand (see MedicineDetail.jsx) —
   framed like a document rather than dropped in edge-to-edge. */
.medicine-highlight-card {
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  background: var(--surface);
}
.medicine-highlight-card img {
  display: block;
  width: 100%;
  height: auto;
}

.product-detail-container h2,
.product-detail-container h3.title {
  font-family: var(--font-display);
  font-size: var(--fs-h1);
  margin-bottom: 8px;
  letter-spacing: -0.025em;
}
/* Product spec sheet — plain label/value row divided by hairlines, not
   boxed tiles, so the medicine detail page doesn't repeat the card pattern. */
.product-spec-row {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  border-top: 1px solid var(--ink-200);
  border-bottom: 1px solid var(--ink-200);
}
.product-spec-item {
  flex: 1 1 25%;
  min-width: 140px;
  padding: 18px 20px 18px 0;
  margin-right: 20px;
  border-right: 1px solid var(--ink-200);
}
.product-spec-item:last-child { border-right: none; margin-right: 0; }
.product-spec-row dt {
  font-size: 11px;
  color: var(--ink-500);
  text-transform: uppercase;
  letter-spacing: 0.10em;
  font-weight: 600;
  margin-bottom: 6px;
}
.product-spec-row dd {
  font-family: var(--font-display);
  font-size: 15px;
  margin: 0;
  color: var(--ink-900);
  font-weight: 600;
}
@media (max-width: 767px) {
  .product-spec-item {
    flex: 1 1 45%;
    border-right: none;
    border-bottom: 1px solid var(--ink-200);
    padding: 14px 0;
    margin-right: 0;
  }
  .product-spec-item:nth-child(odd) { padding-right: 16px; }
}

.rx-notice {
  border-left: 3px solid var(--brand-secondary);
  background: var(--brand-secondary-soft);
  padding: 16px 20px;
  border-radius: 0 var(--radius-md) var(--radius-md) 0;
  color: var(--ink-800);
  font-size: 14px;
  margin: 24px 0;
}
.rx-notice strong { color: var(--brand-secondary); font-weight: 700; }
.custom-section-bg { background: var(--surface-2); }

/* =========================================================================
   Distributor cards + search/filter bar
   ========================================================================= */

.distributor-card, .services-block-three {
  padding: 24px !important;
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-lg);
  background: var(--surface);
  height: 100%;
  transition: all var(--dur) var(--ease-out);
}
.distributor-card:hover, .services-block-three:hover {
  border-color: var(--brand-primary);
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}
.distributor-card h3, .services-block-three h3 {
  font-family: var(--font-display);
  font-size: 17px;
  margin-bottom: 14px;
  color: var(--ink-900);
  letter-spacing: -0.01em;
}
.distributor-card p, .services-block-three p {
  color: var(--ink-500);
  font-size: 14px;
  line-height: 1.6;
}
.distributor-card-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 10px;
}
.distributor-card-icon {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: var(--brand-primary-soft);
  color: var(--brand-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
}
.distributor-card-row p { margin: 0; font-size: 13.5px; line-height: 1.5; }
.distributor-card-row a {
  font-size: 13.5px;
  color: var(--brand-primary);
  font-weight: 600;
  text-decoration: none;
}
.distributor-card-row a:hover { text-decoration: underline; }

/* Unified filter bar — state/city (react-select) and search used to sit in
   mismatched boxes (a tinted padded wrapper around the selects, a plain
   bordered input for search). One bordered panel, one background everywhere. */
.distributor-filter-bar {
  background: var(--surface);
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  padding: 24px;
  margin-bottom: 40px;
}
.custom-select {
  background: transparent !important;
  padding: 0 !important;
  border-radius: 0 !important;
}
.distributor-search { position: relative; }
.distributor-search .form-control { padding-left: 44px !important; }
.distributor-search .search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--ink-400);
  display: inline-flex;
  pointer-events: none;
}

/* =========================================================================
   FAQ
   ========================================================================= */

.faq-list { max-width: 820px; margin: 0 auto; }
.faq-list .faq-item {
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-md);
  margin-bottom: 12px;
  background: var(--surface);
  overflow: hidden;
  transition: border-color var(--dur) var(--ease-out), box-shadow var(--dur) var(--ease-out);
}
.faq-list .faq-item[open] { border-color: var(--brand-primary); box-shadow: var(--shadow-sm); }
.faq-list .faq-item summary {
  padding: 20px 24px;
  cursor: pointer;
  font-family: var(--font-display);
  font-weight: 600;
  color: var(--ink-900);
  list-style: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  font-size: 16px;
  letter-spacing: -0.005em;
}
.faq-list .faq-item summary::-webkit-details-marker { display: none; }
.faq-list .faq-item summary::after {
  content: "";
  width: 28px; height: 28px;
  border-radius: 50%;
  background: var(--brand-primary-soft);
  color: var(--brand-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: center;
  transition: transform var(--dur) var(--ease-out);
}
.faq-list .faq-item[open] summary::after { transform: rotate(-180deg); }
.faq-list .faq-item .faq-body {
  padding: 0 24px 24px;
  color: var(--ink-600);
  font-size: 15px;
  line-height: 1.75;
}

/* =========================================================================
   Footer
   ========================================================================= */

.footer {
  background: linear-gradient(180deg, var(--brand-dark) 0%, var(--brand-dark-2) 100%) !important;
  color: rgba(255, 255, 255, 0.65);
  padding-top: 0;
  padding-bottom: 0;
  border-top: none;
  position: relative;
}
/* A slim brand-gradient signature line at the very top edge, where the page
   content (white) meets the footer (dark) — a common premium-footer touch. */
.footer::before {
  content: "";
  position: absolute;
  inset: 0 0 auto 0;
  height: 3px;
  background: linear-gradient(90deg, var(--brand-primary) 0%, var(--brand-secondary) 100%);
  z-index: 1;
}
/* Template reserved 200px of top padding here for its decorative wave graphic
   (removed above, legacy purple) — that space was never reclaimed. */
.footer .footer-top {
  padding: 64px 0 12px !important;
}
/* Template's decorative wave (footer-shape.png) shipped in the legacy purple —
   the gradient + top accent line above already give the footer a defined edge. */
.footer::after { content: none !important; }
.footer .footer-title,
.footer h3.footer-title {
  color: #fff;
  font-family: var(--font-sans);
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.14);
}
/* Same story: template's purple footer-line.png underline duplicated the border above. */
.footer .widget .footer-title::after { content: none !important; }
.footer .widget ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.footer .widget ul li { margin-bottom: 9px; }
.footer .widget ul li a,
.footer .widget ul li a span {
  color: rgba(255, 255, 255, 0.65);
  font-size: 14px;
  font-weight: 500;
  transition: color var(--dur) var(--ease-out);
}
.footer .widget ul li a:hover,
.footer .widget ul li a:hover span { color: #fff; }
.footer .widget ul li a.footer-view-all,
.footer .widget ul li a.footer-view-all span {
  color: #4FC3E0;
  font-weight: 700;
}
.footer .widget ul li a.footer-view-all:hover,
.footer .widget ul li a.footer-view-all:hover span { color: #fff; }
.footer .ft-contact p { color: rgba(255, 255, 255, 0.55); font-size: 14px; line-height: 1.7; }
.footer .foot-contact {
  align-items: flex-start !important;
  gap: 12px !important;
  padding: 4px 0;
}
.footer .foot-contact > span:first-child {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.14);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.footer .foot-contact a, .footer .foot-contact span.fw-medium {
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
  padding-top: 4px;
  line-height: 1.5;
  transition: color var(--dur) var(--ease-out);
}
.footer .foot-contact a:hover { color: #fff; }
.footer .footer-social-link ul li a {
  border-radius: 10px !important;
  background: rgba(255, 255, 255, 0.08) !important;
  border: 1px solid rgba(255, 255, 255, 0.14) !important;
  color: #fff !important;
  box-shadow: none;
}
.footer .footer-social-link ul li a:hover {
  background: var(--brand-primary) !important;
  color: #fff !important;
  border-color: var(--brand-primary) !important;
  transform: translateY(-1px);
}
.footer .footer-bottom {
  padding: 22px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.footer .copyright-text { color: rgba(255, 255, 255, 0.5); font-size: 13px; }
.footer .copyright-text a { color: rgba(255, 255, 255, 0.7); }
.footer .copyright-text a:hover { color: #fff; }
.footer .custom-links a span { color: rgba(255, 255, 255, 0.6); font-size: 13px; transition: color var(--dur) var(--ease-out); }
.footer .custom-links a:hover span { color: #fff; }
.footer .pt-img1, .footer .pt-img2, .footer .pt-img3, .footer .pt-img4 { opacity: 0.12; }

/* =========================================================================
   Team
   ========================================================================= */

.team-member {
  border-radius: var(--radius-lg);
  overflow: hidden;
  background: var(--surface);
  border: 1px solid var(--ink-200);
  transition: all var(--dur) var(--ease-out);
  height: 100%;
  display: flex;
  flex-direction: column;
}
.team-member:hover { box-shadow: var(--shadow-md); transform: translateY(-3px); }
.team-member .team-media {
  aspect-ratio: 1 / 1;
  overflow: hidden;
  background: var(--brand-primary-soft);
  /* Template's own .team-member .team-media rule (App.css) chains 2 classes —
     equal or higher specificity than this file's old bare \`.team-media\`
     selector, so its \`padding: 20%\` kept winning and shrank the photo into a
     fraction of the square, leaving a wide soft-blue border around it.
     Matching the selector here (not just relying on cascade order) is what
     actually overrides it. */
  padding: 0;
}
.team-member .team-media img {
  /* Same specificity problem for the image itself: the template masks every
     team photo into its decorative hexagon (\`mask-image: url(shape3.png)\`)
     and adds \`padding-top: 40px\`, both sized for template stock photography,
     not these headshots — real photos ended up cropped into a tiny hexagon
     island floating in a sea of the container's background color. Photos are
     plain rectangular avatars in this design, so drop the mask entirely. */
  mask-image: none;
  padding-top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform var(--dur-slow) var(--ease-out);
}
.team-member .team-media:before,
.team-member .team-media:after {
  /* Decorative background blobs (shape1.png/shape2.png) meant to peek out
     around the hexagon-masked photo — with the mask gone there's no gap for
     them to show through, and \`.team-media\`'s own overflow: hidden clips them. */
  content: none;
}
.team-member:hover .team-media img { transform: scale(1.04); }
.team-info {
  padding: 22px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}
.team-info h4 { font-family: var(--font-display); font-size: 17px; margin-bottom: 4px; letter-spacing: -0.01em; }
.team-info .text-secondary { font-size: 12px; letter-spacing: 0.10em; text-transform: uppercase; font-weight: 600; }
.team-info .social-media { list-style: none; padding: 0; margin: 16px 0 0; display: flex; justify-content: center; gap: 8px; }
.team-info .social-media a {
  width: 36px; height: 36px; border-radius: 10px;
  border: 1px solid var(--ink-200);
  color: var(--brand-primary);
  display: inline-flex; align-items: center; justify-content: center;
  transition: all var(--dur) var(--ease-out);
}
.team-info .social-media a:hover { background: var(--brand-primary); color: #fff; border-color: var(--brand-primary); }

/* =========================================================================
   Home about section
   ========================================================================= */

.about-area {
  padding: 96px 0 !important;
}
.about-area .heading-bx .title {
  font-family: var(--font-display);
  font-size: var(--fs-h1);
  margin-bottom: 16px;
  letter-spacing: -0.025em;
}
.about-area .heading-bx .title em {
  font-family: var(--font-serif);
  font-style: italic;
  font-weight: 400;
  color: var(--brand-primary);
}
.about-area .heading-bx p { color: var(--ink-500); font-size: 1.0625rem; line-height: 1.7; }

/* About portrait — mirrors the hero's offset-card + floating-chip treatment
   so the page reads as one design system rather than two different styles. */
.about-portrait {
  position: relative;
  padding: 16px 16px 40px 16px;
}
.about-portrait::before {
  content: "";
  position: absolute;
  inset: 36px 0 16px 36px;
  background: var(--grad-brand);
  border-radius: var(--radius-2xl);
  transform: rotate(3deg);
  z-index: 0;
  box-shadow: var(--shadow-lg);
}
.about-portrait img {
  position: relative;
  z-index: 1;
  width: 100%;
  height: auto;
  aspect-ratio: 4 / 4.3;
  object-fit: cover;
  border-radius: var(--radius-2xl);
  box-shadow: var(--shadow-lg);
  background: #fff;
  display: block;
}
.about-portrait-chip {
  position: absolute;
  z-index: 2;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: var(--surface);
  border-radius: var(--radius-lg);
  padding: 16px 20px;
  box-shadow: var(--shadow-lg);
  max-width: 240px;
}
.about-portrait-chip .value {
  font-family: var(--font-serif);
  font-size: 1.5rem;
  color: var(--brand-primary);
  line-height: 1;
}
.about-portrait-chip .label {
  font-size: 12.5px;
  color: var(--ink-600);
  font-weight: 600;
  line-height: 1.4;
  margin-top: 6px;
}
@media (max-width: 991px) {
  .about-portrait-chip { max-width: 220px; padding: 14px 18px; }
}

.feature-container.feature-bx1 {
  padding: 22px;
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-lg);
  background: var(--surface);
  transition: all var(--dur) var(--ease-out);
}
/* Template gave feature1–4 a rainbow of decorative corner glows (cyan/green/pink/purple)
   via :after — kill them all so every value card matches the brand's 2-color palette. */
.feature-bx1::after,
.feature-bx1.feature1::after,
.feature-bx1.feature2::after,
.feature-bx1.feature3::after,
.feature-bx1.feature4::after {
  content: none !important;
}
.feature-container.feature-bx1:hover {
  border-color: var(--brand-primary);
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}
.feature-container.feature-bx1 .icon-md {
  width: 52px; height: 52px;
  border-radius: 14px;
  background: var(--brand-primary-soft);
  display: inline-flex; align-items: center; justify-content: center;
  margin-bottom: 14px;
}
.feature-container.feature-bx1 .ttr-title {
  font-family: var(--font-display);
  font-size: 16px;
  color: var(--ink-900);
  margin: 0;
  letter-spacing: -0.01em;
}

.about-thumb-area ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
.about-thumb-area ul li img {
  width: 100%;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  aspect-ratio: 1 / 1;
  object-fit: cover;
}

/* Contact page icon boxes */
.feature-bx4 {
  padding: 32px 24px;
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-lg);
  background: var(--surface);
  text-align: center;
  transition: all var(--dur) var(--ease-out);
}
.feature-bx4:hover { border-color: var(--brand-primary); box-shadow: var(--shadow-md); transform: translateY(-2px); }
.feature-bx4 .feature-icon {
  width: 60px; height: 60px;
  border-radius: 16px;
  background: var(--brand-primary-soft);
  display: inline-flex; align-items: center; justify-content: center;
  margin: 0 auto 14px;
}
.feature-bx4 .feature-icon img { width: 30px; height: 30px; object-fit: contain; }
.feature-bx4 .ttr-title { font-family: var(--font-display); margin-bottom: 8px; letter-spacing: -0.01em; }

/* Kill decorative shapes on home sections */
.about-area .pt-img1,
.about-area .pt-img2,
.about-area .pt-img3,
.about-area .pt-img4,
.about-area .pt-img5,
.team-wraper .pt-img1,
.team-wraper .pt-img2,
.team-wraper .pt-img3,
.team-wraper .pt-img4,
.team-wraper .pt-img5 { display: none !important; }
.testimonial-wraper .pt-img1,
.testimonial-wraper .pt-img2,
.testimonial-wraper .pt-img3,
.testimonial-wraper .pt-img4 { opacity: 0.25; }

/* =========================================================================
   Services slider (Why Clametis)
   ========================================================================= */

.service-wraper .heading-bx { text-align: center; margin-bottom: 40px; }
.service-wraper .heading-bx h6 { justify-content: center; }
.service-wraper .feature-bx2 {
  padding: 32px 28px;
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-lg);
  background: var(--surface);
  height: 100%;
  transition: all var(--dur) var(--ease-out);
  text-align: center;
}
.service-wraper .feature-bx2:hover {
  border-color: var(--brand-primary);
  box-shadow: var(--shadow-md);
  transform: translateY(-4px);
}
.service-wraper .feature-bx2 .feature-box-xl {
  width: 84px; height: 84px;
  border-radius: 20px;
  background: var(--brand-primary-soft);
  display: inline-flex; align-items: center; justify-content: center;
  margin: 0 auto 18px;
}
.service-wraper .feature-bx2 .feature-box-xl svg { max-width: 40px; max-height: 40px; }
.service-wraper .feature-bx2 .ttr-title {
  font-family: var(--font-display);
  color: var(--ink-900); margin-bottom: 8px;
  font-size: 17px; letter-spacing: -0.01em;
}
.service-wraper .feature-bx2 p { color: var(--ink-500); font-size: 14px; margin: 0; }

.slick-arrow { display: none !important; }

/* =========================================================================
   Partners
   ========================================================================= */

.our-partner-box {
  padding: 20px 32px;
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-md);
  background: var(--surface);
  transition: all var(--dur) var(--ease-out);
  min-height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.our-partner-box img {
  max-height: 50px;
  object-fit: contain;
  filter: grayscale(30%);
  opacity: 0.85;
  transition: all var(--dur) var(--ease-out);
}
.our-partner-box:hover { border-color: var(--brand-primary); box-shadow: var(--shadow-sm); }
.our-partner-box:hover img { filter: none; opacity: 1; }

/* =========================================================================
   Back-to-top + WhatsApp float
   ========================================================================= */

.scroltop {
  background: var(--brand-primary) !important;
  color: #fff !important;
  border-radius: 12px !important;
  box-shadow: var(--shadow-md) !important;
}
.wa-float {
  position: fixed;
  /* Stacked above .back-to-top (bottom:15px, 45px tall) so the two never overlap. */
  bottom: 76px; right: 24px;
  z-index: 999;
  background: #25D366;
  color: #fff;
  border-radius: 16px;
  width: 56px; height: 56px;
  display: inline-flex; align-items: center; justify-content: center;
  box-shadow: var(--shadow-md);
  font-size: 24px;
}
.wa-float:hover { background: #128C7E; color: #fff; transform: translateY(-3px); box-shadow: var(--shadow-lg); }

/* Realign the template's back-to-top button under the WhatsApp float and match its radius. */
button.back-to-top {
  right: 24px !important;
  bottom: 15px !important;
  border-radius: 16px !important;
  width: 48px !important;
  height: 48px !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.sr-only {
  position: absolute; width: 1px; height: 1px;
  padding: 0; margin: -1px; overflow: hidden;
  clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;
}

/* Motion respect */
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
  .animate-wave, .animate1, .animate2, .animate3, .animate4,
  .animate5, .animate-rotate, [class^="animate-"], [class*=" animate-"] {
    animation: none !important;
  }
}

/* =========================================================================
   Mobile carousels — some card grids (4-6 short items) stacked into very
   long single-column scrolls on mobile with nothing but repeated cards for
   a full screen or more at a time. Below 767px, \`.mobile-carousel\` turns
   the row into a horizontal, snap-scrolling strip instead — same cards,
   a fraction of the scroll height, and the partial next-card peek signals
   it's swipeable. Desktop/tablet grid layout (untouched) still applies
   above this breakpoint.
   ========================================================================= */
@media (max-width: 767px) {
  .mobile-carousel {
    display: flex !important;
    flex-wrap: nowrap !important;
    overflow-x: auto !important;
    /* Leaving overflow-y unset would compute to \`auto\` too (CSS resolves a
       'visible' axis to 'auto' whenever the other axis isn't 'visible'),
       turning this into a vertical scroll container as well. With nothing
       inside it to vertically overflow that traps rather than scrolls — a
       trackpad/mouse-wheel scroll (an iPad with a trackpad, e.g.) landing on
       the strip stops moving the page entirely. Pin it to hidden so vertical
       scroll always passes through to the page; only horizontal is ours. */
    overflow-y: hidden;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    margin-left: calc(-1 * var(--container-pad)) !important;
    margin-right: calc(-1 * var(--container-pad)) !important;
    padding-left: var(--container-pad) !important;
    padding-right: var(--container-pad) !important;
    padding-bottom: 12px;
    scrollbar-width: none;
  }
  .mobile-carousel::-webkit-scrollbar { display: none; }
  .mobile-carousel > * {
    flex: 0 0 82% !important;
    max-width: 82% !important;
    scroll-snap-align: start;
  }
}

/* =========================================================================
   Mobile refinements
   ========================================================================= */

@media (max-width: 767px) {
  .menu-bar > .container-fluid { height: 72px !important; padding-left: 20px !important; padding-right: 20px !important; }
  .header .menu-logo img, .rs-nav .menu-logo img { height: 40px !important; max-height: 40px !important; }
  .header.is-stuck .menu-bar > .container-fluid { height: 60px !important; }
  .header.is-stuck .menu-logo img, .rs-nav.is-stuck .menu-logo img { height: 34px !important; max-height: 34px !important; }
  .main-banner { padding: 112px 0 60px !important; }
  .main-banner h1 { font-size: 2.25rem !important; }
  .main-banner .banner-img { margin-top: 32px; padding: 12px !important; }
  .main-banner .banner-img::before { inset: 12px !important; }
  .page-banner { padding: 32px 0 18px !important; }
  .page-banner h1 { font-size: 1.625rem; }
  .stats-strip { padding: 48px 0; }
  .stats-strip .stat-value { font-size: 2.25rem; }
  .prefooter-cta { margin: 48px 12px; padding: 48px 24px; }
  .prefooter-cta h2 { font-size: 1.75rem; }
  .testimonial-bx { padding: 32px 24px; }
  .testimonial-bx .testimonial-content p { font-size: 1.15rem; }
  .blog-detail-card .info-bx { padding: 24px; }
  .form-wraper { padding: 24px; }
  .distributor-filters { flex-direction: column; gap: 12px; }
  .distributor-filters > * { width: 100% !important; }
}

/* =========================================================================
   Kill legacy floating shape animations everywhere they clash
   ========================================================================= */

.page-content > .banner-wraper .pt-img1,
.page-content > .banner-wraper .pt-img2,
.page-content > .banner-wraper .pt-img3 { opacity: 0.20; }
`, "",{"version":3,"sources":["webpack://./src/css/brand-overrides.css"],"names":[],"mappings":"AAAA;;;;8EAI8E;;AAE9E;EACE,UAAU;EACV,wBAAwB;EACxB,8BAA8B;EAC9B,gCAAgC;EAChC,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,qBAAqB;EACrB,uBAAuB;;EAEvB,+DAA+D;EAC/D,oEAAoE;EACpE;;mEAEiE;;EAEjE,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;;EAEpB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;;EAEpB,WAAW;EACX,6CAA6C;EAC7C,gFAAgF;EAChF,iFAAiF;EACjF,kFAAkF;EAClF,+CAA+C;EAC/C,oFAAoF;EACpF,2FAA2F;EAC3F,gGAAgG;;EAEhG,WAAW;EACX,yCAAyC;EACzC,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;;EAEjB;sFACoF;EACpF,yGAAyG;EACzG,+DAA+D;EAC/D,6DAA6D;;EAE7D,4CAA4C;EAC5C,gDAAgD;EAChD,6CAA6C;EAC7C,+CAA+C;EAC/C,6CAA6C;EAC7C,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;;EAErB,qBAAqB;EACrB,qBAAqB;;EAErB,wBAAwB;EACxB,qBAAqB;EACrB,6BAA6B;EAC7B,wBAAwB;EACxB,gCAAgC;EAChC,8BAA8B;EAC9B,sCAAsC;EACtC,wBAAwB;EACxB,gCAAgC;EAChC,2BAA2B;EAC3B,uCAAuC;EACvC,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;;8EAG8E;;AAE9E;EACE,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;EACjC;;kCAEgC;EAChC,+CAA+C;EAC/C,8CAA8C;EAC9C,4CAA4C;EAC5C,6BAA6B;EAC7B,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;;;;EAIE,wBAAwB;EACxB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;sEACsE;AACtE;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;;EAEE,2CAA2C;EAC3C,2BAA2B;EAC3B,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;EAC5B,mCAAmC;EACnC,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;EAC3B,iCAAiC;AACnC;AACA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,6BAA6B;EAC7B,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA,uDAAuD;AACvD;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,gCAAgC;EAChC,iCAAiC;EACjC,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uCAAuC;EACvC,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,gCAAgC,UAAU,EAAE,aAAa,EAAE;AAC7D;AACA;EACE,gCAAgC,aAAa,EAAE;AACjD;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,kCAAkC;EAClC,oBAAoB;EACpB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,sBAAsB;EACtB,wCAAwC;EACxC,2CAA2C;EAC3C,mCAAmC;EACnC,qBAAqB;EACrB,uCAAuC;AACzC;AACA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,2CAA2C;EAC3C,uCAAuC;EACvC,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,qBAAqB;EACrB,uCAAuC;EACvC,sCAAsC;EACtC,oCAAoC;EACpC,iCAAiC;EACjC,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;;;;wBAIwB,wBAAwB,EAAE;;AAElD,uEAAuE;AACvE;EACE,wBAAwB;EACxB,2DAA2D;EAC3D,iBAAiB;EACjB,+CAA+C;EAC/C,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;AACA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,gCAAgC;EAChC,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,wCAAwC;EACxC,0BAA0B;EAC1B,iCAAiC;EACjC,oCAAoC;EACpC,gCAAgC;EAChC,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,gCAAgC,6BAA6B,EAAE;EAC/D,gCAAgC,0BAA0B,EAAE;AAC9D;;AAEA;;8EAE8E;;AAE9E,OAAO,8BAA8B,EAAE;;AAEvC;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;EAChB,6CAA6C;EAC7C,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;AACA,UAAU,uBAAuB,EAAE,uBAAuB,EAAE;AAC5D,UAAU,uBAAuB,EAAE,wBAAwB,EAAE;AAC7D,UAAU,uBAAuB,EAAE;AACnC,UAAU,uBAAuB,EAAE;AACnC,UAAU,uBAAuB,EAAE;;AAEnC,IAAI,qBAAqB,EAAE,iBAAiB,EAAE;;AAE9C;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,SAAS,8BAA8B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACpF,gBAAgB,8BAA8B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAEtF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,kBAAkB;AACpB;AACA;0BAC0B,wCAAwC,EAAE;;AAEpE;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,UAAU;AACV,SAAS,aAAa,EAAE;AACxB;EACE,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;AACpB;AACA,IAAI,2BAA2B,EAAE,qBAAqB,EAAE,4CAA4C,EAAE;AACtG,UAAU,iCAAiC,EAAE;AAC7C;EACE;;;;kDAIgD;AAClD;;AAEA;;8EAE8E;;AAE9E;EACE,6CAA6C;EAC7C,8CAA8C;EAC9C,4BAA4B;EAC5B,6BAA6B;EAC7B,sBAAsB;EACtB,iCAAiC;AACnC;AACA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA,6BAA6B,aAAa,2BAA2B,EAAE,EAAE;AACzE,6BAA6B,aAAa,2BAA2B,EAAE,EAAE;AACzE,6BAA6B,aAAa,2BAA2B,EAAE,EAAE;AACzE,6BAA6B,aAAa,4BAA4B,EAAE,EAAE;AAC1E,6BAA6B,aAAa,4BAA4B,EAAE,EAAE;AAC1E,6BAA6B,aAAa,4BAA4B,EAAE,EAAE;;AAE1E,yBAAyB,kBAAkB,EAAE;AAC7C;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE;IACE,kBAAkB;IAClB,qBAAqB;EACvB;AACF;AACA,gBAAgB,4BAA4B,EAAE;AAC9C;sFACsF;AACtF;EACE,4BAA4B;AAC9B;AACA,sBAAsB,kCAAkC,EAAE;;AAE1D;;;;uCAIuC;AACvC;;;;;;EAME,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE;;;;;;IAME,iBAAiB;IACjB,oBAAoB;EACtB;AACF;AACA;;;;;;EAME,4BAA4B;AAC9B;AACA;EACE,0BAA0B;AAC5B;;AAEA;;;;;;;;;;;;;;;mEAemE;;AAEnE;;;EAGE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,kCAAkC;EAClC;;;;;;4DAM0D;EAC1D,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;+BAE+B;AAC/B;;;;EAIE,2BAA2B;EAC3B,kCAAkC;EAElC,gCAAgC;EAChC,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,+CAA+C;EAC/C,2BAA2B;EAC3B,wBAAwB;EACxB;;;;;oCAKkC;EAClC,2BAA2B;AAC7B;AACA,kFAAkF;AAClF;;EAEE,8BAA8B;EAC9B,8CAA8C;EAC9C,wDAAwD;AAC1D;AACA;;2BAE2B;AAC3B;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,6BAA6B;EAC7B,oBAAoB;EACpB,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,wDAAwD;AAC1D;AACA;EACE;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;AACF;AACA,8BAA8B;AAC9B;EACE,uBAAuB;AACzB;AACA;;;;uDAIuD;AACvD,gBAAgB,iBAAiB,EAAE;AACnC;EACE,gBAAgB,iBAAiB,EAAE;AACrC;;AAEA,4EAA4E;AAC5E;;EAEE,+BAA+B;EAC/B,8BAA8B;EAC9B,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE;;IAEE,6BAA6B;IAC7B,qBAAqB;IACrB,mBAAmB;IACnB,sCAAsC;EACxC;AACF;AACA;;EAEE,+BAA+B;EAC/B,8BAA8B;EAC9B,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,2EAA2E;AAC3E;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,+BAA+B;EAC/B,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE;;IAEE,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;IACnB,sCAAsC;EACxC;AACF;AACA;;EAEE,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA,4EAA4E;AAC5E;EACE;;IAEE,6BAA6B;IAC7B,oBAAoB;IACpB,mBAAmB;IACnB,2CAA2C;IAC3C,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;EACvB;AACF;AACA;;EAEE,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;;EAEE,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;;EAEE,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;;;EAGE,wCAAwC;EACxC,2BAA2B;EAC3B,4BAA4B;EAC5B,gCAAgC;EAChC,mCAAmC;EACnC,6BAA6B;EAC7B,4CAA4C;EAC5C,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,8FAA8F;AAChG;AACA;;;EAGE,sCAAsC;EACtC,gDAAgD;AAClD;AACA;;;EAGE,sCAAsC;EACtC,gDAAgD;AAClD;AACA,uBAAuB,4BAA4B,EAAE,6BAA6B,EAAE;;AAEpF,mBAAmB;AACnB;EACE;sCACoC,+BAA+B,EAAE;EACrE;4BAC0B,wBAAwB,EAAE;EACpD;;IAEE,wBAAwB;IACxB,UAAU;IACV,kBAAkB;EACpB;EACA;;IAEE,wBAAwB;IACxB,UAAU;IACV,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;IACnB,wBAAwB;IACxB,qCAAqC;IACrC,wBAAwB;IACxB,iCAAiC;IACjC,+BAA+B;IAC/B,sCAAsC;IACtC,2BAA2B;IAC3B,sBAAsB;IACtB,wBAAwB;IACxB,0BAA0B;EAC5B;EACA;IACE,iCAAiC;IACjC,mBAAmB;IACnB,sBAAsB;IACtB,0BAA0B;IAC1B,+BAA+B;EACjC;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,0BAA0B;IAC1B,8BAA8B;IAC9B,gCAAgC;IAChC,kCAAkC;EACpC;EACA;IACE,gDAAgD;IAChD,sCAAsC;EACxC;EACA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,kDAAkD;EACpD;EACA;IACE,+BAA+B;IAC/B,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,gCAAgC;IAChC,0BAA0B;IAC1B,gCAAgC;IAChC,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;AACF;AACA;EACE;4BAC0B,wBAAwB,EAAE;EACpD;4BAC0B,wBAAwB,EAAE;AACtD;;AAEA;;8EAE8E;;AAE9E;EACE,+BAA+B;EAC/B;;kCAEgC;EAChC,+CAA+C;EAC/C,8CAA8C;EAC9C,4CAA4C;EAC5C,6BAA6B;EAC7B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;sBACsB,wBAAwB,EAAE,wBAAwB,EAAE;AAC1E;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,gCAAgC;EAChC,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gDAAgD;EAChD,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,QAAQ;EACR,iBAAiB;EACjB,0BAA0B;EAC1B,gCAAgC;EAChC,iCAAiC;EACjC,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA,uCAAuC,2BAA2B,EAAE;AACpE;EACE,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;AACA,6BAA6B,qBAAqB,EAAE;AACpD,mCAAmC,2BAA2B,EAAE;AAChE;;;;wBAIwB,aAAa,EAAE;;AAEvC;;8EAE8E;;AAE9E;EACE,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;AACxB;AACA,UAAU,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE;AAC1D,UAAU,cAAc,EAAE,cAAc,EAAE,iBAAiB,EAAE;;AAE7D;;EAEE,2CAA2C;EAC3C,6CAA6C;EAC7C,sBAAsB;EACtB,wCAAwC;AAC1C;AACA;;EAEE,iDAAiD;EACjD,mDAAmD;EACnD,sBAAsB;EACtB,8CAA8C;EAC9C,2BAA2B;AAC7B;AACA;EACE,mDAAmD;EACnD,wBAAwB;AAC1B;AACA;EACE,gDAAgD;EAChD,sCAAsC;EACtC,oCAAoC;EACpC,2BAA2B;AAC7B;AACA,4BAA4B,mBAAmB,EAAE;;AAEjD;;EAEE,6CAA6C;EAC7C,+CAA+C;EAC/C,sBAAsB;EACtB,kDAAkD;AACpD;AACA;;EAEE,mDAAmD;EACnD,qDAAqD;EACrD,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,kDAAkD;EAClD,wCAAwC;EACxC,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;EACE,kCAAkC;EAClC,6CAA6C;EAC7C,gCAAgC;EAChC,2BAA2B;AAC7B;AACA;;EAEE,qCAAqC;EACrC,uCAAuC;EACvC,sBAAsB;EACtB,2BAA2B;AAC7B;AACA,gBAAgB,gDAAgD,EAAE;AAClE,sBAAsB,0BAA0B,EAAE;;AAElD,gBAAgB,sCAAsC,EAAE;AACxD,kBAAkB,wCAAwC,EAAE;AAC5D,cAAc,2CAA2C,EAAE;AAC3D,gBAAgB,6CAA6C,EAAE;AAC/D,WAAW,wCAAwC,EAAE;;AAErD;;8EAE8E;;AAE9E;;;;;EAKE,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B;;qDAEmD;AACrD;AACA;;;;;EAKE,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;;8EAE8E;AAC9E;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;AAC5B;AACA,4BAA4B,kBAAkB,EAAE,oBAAoB,EAAE;AACtE,uCAAuC,iBAAiB,EAAE;AAC1D;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,SAAS;EACT,UAAU;EACV,0BAA0B;AAC5B;AACA,+CAA+C,aAAa,EAAE;AAC9D,mBAAmB,kBAAkB,EAAE,UAAU,EAAE;;AAEnD;;4EAE4E;AAC5E,sBAAsB,cAAc,EAAE;AACtC;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,+BAA+B,mBAAmB,EAAE;EACpD,6BAA6B,kBAAkB,EAAE;AACnD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,oCAAoC;EACpC,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,uCAAuC;EACvC,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,sBAAsB,eAAe,EAAE,kBAAkB,EAAE,uBAAuB,EAAE;AACpF,qBAAqB,SAAS,EAAE,qBAAqB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC5F;EACE,cAAc,0BAA0B,EAAE;AAC5C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,qCAAqC;EACrC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,qBAAqB;AACvB;AACA,aAAa,uCAAuC,EAAE,6BAA6B,EAAE;;AAErF;;8EAE8E;;AAE9E;EACE,eAAe;EACf,0BAA0B;EAC1B,oCAAoC;EACpC,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;8EAE8E;;AAE9E,gBAAgB,kBAAkB,EAAE,mBAAmB,EAAE;AACzD,qBAAqB,gBAAgB,EAAE,mBAAmB,EAAE;AAC5D;EACE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,wBAAwB;AAC1B;AACA,sBAAsB,cAAc,EAAE;AACtC,2BAA2B,SAAS,EAAE;;AAEtC;;8EAE8E;;AAE9E;EACE,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;EACZ,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB;;qDAEmD;EACnD,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA,2CAA2C,aAAa,EAAE;AAC1D,kCAAkC,kBAAkB,EAAE,UAAU,EAAE;;AAElE;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mFAAmF;AACrF;AACA;EACE,gCAAgC;EAChC,WAAW;AACb;AACA,kCAAkC,WAAW,EAAE,YAAY,EAAE;AAC7D;EACE,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;AACvB;AACA,gCAAgC,qBAAqB,EAAE,SAAS,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACvG;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,0BAA0B;EAC1B,oFAAoF;AACtF;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;;;;8EAI8E;AAC9E;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,uCAAuC;AACzC;AACA,sCAAsC,cAAc,EAAE;AACtD,qCAAqC,mBAAmB,EAAE,iBAAiB,EAAE;AAC7E;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,6BAA6B,eAAe,EAAE,kBAAkB,EAAE,uBAAuB,EAAE;AAC3F,4BAA4B,qBAAqB,EAAE,SAAS,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACnG;EACE,0BAA0B,SAAS,EAAE;EACrC,yBAAyB,WAAW,EAAE,iBAAiB,EAAE;AAC3D;;AAEA;;;;8EAI8E;AAC9E,cAAc,uBAAuB,EAAE;AACvC;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,kCAAkC;EAClC,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,uCAAuC;EACvC,uBAAuB;AACzB;AACA,8BAA8B,cAAc,EAAE;AAC9C,6BAA6B,mBAAmB,EAAE,iBAAiB,EAAE;AACrE;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,qBAAqB,eAAe,EAAE,kBAAkB,EAAE,uBAAuB,EAAE;AACnF,oBAAoB,qBAAqB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAClG;EACE,kBAAkB,SAAS,EAAE;EAC7B,kBAAkB,WAAW,EAAE,YAAY,EAAE;AAC/C;;AAEA;;8EAE8E;;AAE9E;EACE,mFAAmF;EACnF,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;sFAEoF;EACpF,oBAAoB;AACtB;AACA,0BAA0B,kBAAkB,EAAE,UAAU,EAAE;AAC1D,2BAA2B,aAAa,EAAE,qCAAqC,EAAE,MAAM,EAAE;AACzF,4BAA4B,2BAA2B,qCAAqC,EAAE,EAAE;AAChG,qBAAqB,kBAAkB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AACjF;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,OAAO;EACP,UAAU;EACV,qCAAqC;AACvC;AACA;EACE,oDAAoD,aAAa,EAAE;AACrE;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;EACd,WAAW;EACX,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;8EAE8E;;AAE9E;EACE,kBAAkB;EAClB,+FAA+F;EAC/F,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;iFAE+E;EAC/E,oBAAoB;AACtB;AACA,kCAAkC,kBAAkB,EAAE,UAAU,EAAE;AAClE;EACE,WAAW;EACX,gCAAgC;EAChC,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;AACA,mBAAmB,gCAAgC,EAAE,oBAAoB,EAAE;AAC3E;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,6BAA6B;EAC7B,uCAAuC;AACzC;AACA;EACE,8BAA8B;EAC9B,8CAA8C;AAChD;AACA;EACE,iDAAiD;EACjD,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;;8EAE8E;;AAE9E;EACE,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;AACpB;AACA,wCAAwC,aAAa,EAAE;AACvD;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,uCAAuC;EACvC,iCAAiC;AACnC;AACA,4CAA4C,aAAa,EAAE;AAC3D,uCAAuC,eAAe,EAAE,gBAAgB,EAAE;;AAE1E;;sEAEsE;AACtE;EACE,WAAW;AACb;AACA;EACE;;;;;qEAKmE;EACnE,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,2CAA2C;EAC3C,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,mDAAmD;AACrD;AACA,qCAAqC,kCAAkC,EAAE;AACzE;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;AACA;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;EACA,iDAAiD,kBAAkB,EAAE;EACrE;IACE;;;;yCAIqC;IACrC,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,oCAAoC;IACpC,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;AACF;;AAEA;;8EAE8E;;AAE9E;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;EAChB,gIAAgI;AAClI;AACA,mBAAmB,4BAA4B,EAAE,4BAA4B,EAAE,2BAA2B,EAAE;AAC5G;EACE,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qDAAqD;AACvD;AACA,mCAAmC,sBAAsB,EAAE;AAC3D;sBACsB,aAAa,EAAE;AACrC;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;AACA,2BAA2B,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAChF;;EAEE,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;AACA,mBAAmB,sBAAsB,EAAE;;AAE3C,gBAAgB;AAChB;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;AAC5B;AACA,oCAAoC,WAAW,EAAE,YAAY,EAAE;AAC/D,6BAA6B,aAAa,EAAE;AAC5C,gCAAgC,uBAAuB,EAAE;AACzD,sBAAsB,oBAAoB,EAAE,iBAAiB,EAAE;;AAE/D;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,gBAAgB,EAAE,eAAe;EACjC,iBAAiB;EACjB,oCAAoC;AACtC;AACA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,iBAAiB,EAAE,iCAAiC;EACpD,gCAAgC;EAChC,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe,EAAE,gBAAgB;EACjC,qBAAqB;AACvB;AACA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;;8EAE8E;;AAE9E;;;EAGE,6CAA6C;EAC7C,0CAA0C;EAC1C,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;EAChC,qCAAqC;EACrC,wCAAwC;AAC1C;AACA,6BAA6B,qBAAqB,EAAE;AACpD;EACE,6CAA6C;EAC7C,wDAAwD;EACxD,wBAAwB;AAC1B;AACA,sBAAsB,gCAAgC,EAAE;AACxD;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;AACA,wBAAwB,4BAA4B,EAAE,6BAA6B,EAAE;;AAErF;EACE,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;;8EAE8E;;AAE9E;;;;kEAIkE;AAClE;;EAEE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,+BAA+B;EAC/B,0BAA0B;EAC1B,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gDAAgD;AAClD;AACA,iCAAiC,sBAAsB,EAAE;AACzD;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;AACA,yBAAyB,eAAe,EAAE,qBAAqB,EAAE,SAAS,EAAE;;AAE5E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,0BAA0B;EAC1B,kCAAkC;EAClC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,0CAA0C;EAC1C,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,+DAA+D;AACjE;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;;mCAEmC;AACnC;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;EAC1B,cAAc;EACd,0CAA0C;AAC5C;AACA,8BAA8B,YAAY,EAAE,eAAe,EAAE;AAC7D;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,4CAA4C;AAC9C;AACA,gCAAgC,kCAAkC,EAAE,4BAA4B,EAAE;AAClG;EACE,kCAAkC;EAClC,qCAAqC;EACrC,4BAA4B;AAC9B;AACA,yBAAyB,2BAA2B,EAAE;;AAEtD;EACE,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,uCAAuC;AACzC;AACA,oCAAoC,eAAe,EAAE,gBAAgB,EAAE;;AAEvE;;;;8EAI8E;AAC9E;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,kCAAkC;EAClC,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,eAAe;AACjB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,qCAAqC;AACvC;AACA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;8EAE8E;;AAE9E;EACE;;;;0CAIwC;EACxC,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,gCAAgC;EAChC,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,6BAA6B,iBAAiB,EAAE;;AAEhD;gEACgE;AAChE;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;8EAC8E;AAC9E;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,oCAAoC;EACpC,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;AACxC;AACA,gCAAgC,kBAAkB,EAAE,eAAe,EAAE;AACrE;EACE,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE;IACE,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,eAAe;IACf,eAAe;EACjB;EACA,oCAAoC,mBAAmB,EAAE;AAC3D;;AAEA;EACE,6CAA6C;EAC7C,uCAAuC;EACvC,kBAAkB;EAClB,oDAAoD;EACpD,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;AACA,oBAAoB,6BAA6B,EAAE,gBAAgB,EAAE;AACrE,qBAAqB,4BAA4B,EAAE;;AAEnD;;8EAE8E;;AAE9E;EACE,wBAAwB;EACxB,gCAAgC;EAChC,+BAA+B;EAC/B,0BAA0B;EAC1B,YAAY;EACZ,0CAA0C;AAC5C;AACA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA,0BAA0B,SAAS,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC1E;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;AACvB;AACA,gCAAgC,0BAA0B,EAAE;;AAE5D;;+EAE+E;AAC/E;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,2BAA2B;AAC7B;AACA,sBAAsB,kBAAkB,EAAE;AAC1C,oCAAoC,6BAA6B,EAAE;AACnE;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;8EAE8E;;AAE9E,YAAY,gBAAgB,EAAE,cAAc,EAAE;AAC9C;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,0FAA0F;AAC5F;AACA,4BAA4B,kCAAkC,EAAE,4BAA4B,EAAE;AAC9F;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;AACA,sDAAsD,aAAa,EAAE;AACrE;EACE,WAAW;EACX,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yDAAqR;EACrR,4BAA4B;EAC5B,2BAA2B;EAC3B,gDAAgD;AAClD;AACA,2CAA2C,0BAA0B,EAAE;AACvE;EACE,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;8EAE8E;;AAE9E;EACE,8FAA8F;EAC9F,gCAAgC;EAChC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;6EAC6E;AAC7E;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,wFAAwF;EACxF,UAAU;AACZ;AACA;qEACqE;AACrE;EACE,+BAA+B;AACjC;AACA;iFACiF;AACjF,iBAAiB,wBAAwB,EAAE;AAC3C;;EAEE,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,kDAAkD;AACpD;AACA,yFAAyF;AACzF,uCAAuC,wBAAwB,EAAE;AACjE;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA,wBAAwB,kBAAkB,EAAE;AAC5C;;EAEE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;qCACqC,WAAW,EAAE;AAClD;;EAEE,cAAc;EACd,gBAAgB;AAClB;AACA;qDACqD,WAAW,EAAE;AAClE,wBAAwB,gCAAgC,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC7F;EACE,kCAAkC;EAClC,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA,gCAAgC,WAAW,EAAE;AAC7C;EACE,8BAA8B;EAC9B,gDAAgD;EAChD,sDAAsD;EACtD,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,2CAA2C;EAC3C,sBAAsB;EACtB,6CAA6C;EAC7C,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,+CAA+C;AACjD;AACA,0BAA0B,+BAA+B,EAAE,eAAe,EAAE;AAC5E,4BAA4B,+BAA+B,EAAE;AAC7D,kCAAkC,WAAW,EAAE;AAC/C,+BAA+B,+BAA+B,EAAE,eAAe,EAAE,4CAA4C,EAAE;AAC/H,qCAAqC,WAAW,EAAE;AAClD,yEAAyE,aAAa,EAAE;;AAExF;;8EAE8E;;AAE9E;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;EAChC,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA,qBAAqB,4BAA4B,EAAE,2BAA2B,EAAE;AAChF;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC;;;;;6BAK2B;EAC3B,UAAU;AACZ;AACA;EACE;;;;;2EAKyE;EAEzE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qDAAqD;AACvD;AACA;;EAEE;;iFAE+E;EAC/E,aAAa;AACf;AACA,qCAAqC,sBAAsB,EAAE;AAC7D;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACT;AACA,gBAAgB,gCAAgC,EAAE,eAAe,EAAE,kBAAkB,EAAE,uBAAuB,EAAE;AAChH,6BAA6B,eAAe,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,gBAAgB,EAAE;AACnH,2BAA2B,gBAAgB,EAAE,UAAU,EAAE,gBAAgB,EAAE,aAAa,EAAE,uBAAuB,EAAE,QAAQ,EAAE;AAC7H;EACE,WAAW,EAAE,YAAY,EAAE,mBAAmB;EAC9C,gCAAgC;EAChC,2BAA2B;EAC3B,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,0CAA0C;AAC5C;AACA,mCAAmC,gCAAgC,EAAE,WAAW,EAAE,kCAAkC,EAAE;;AAEtH;;8EAE8E;;AAE9E;EACE,0BAA0B;AAC5B;AACA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA,4BAA4B,qBAAqB,EAAE,oBAAoB,EAAE,gBAAgB,EAAE;;AAE3F;6EAC6E;AAC7E;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,uBAAuB;EACvB,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,uBAAuB,gBAAgB,EAAE,kBAAkB,EAAE;AAC/D;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,+BAA+B;EAC/B,0BAA0B;EAC1B,0CAA0C;AAC5C;AACA;wFACwF;AACxF;;;;;EAKE,wBAAwB;AAC1B;AACA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,WAAW;EACX,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,gCAAgC;EAChC,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,0CAA0C;AAC5C;AACA,qBAAqB,kCAAkC,EAAE,4BAA4B,EAAE,2BAA2B,EAAE;AACpH;EACE,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,mBAAmB;AACrB;AACA,iCAAiC,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACjF,0BAA0B,gCAAgC,EAAE,kBAAkB,EAAE,uBAAuB,EAAE;;AAEzG,4CAA4C;AAC5C;;;;;;;;;wBASwB,wBAAwB,EAAE;AAClD;;;+BAG+B,aAAa,EAAE;;AAE9C;;8EAE8E;;AAE9E,8BAA8B,kBAAkB,EAAE,mBAAmB,EAAE;AACvE,iCAAiC,uBAAuB,EAAE;AAC1D;EACE,kBAAkB;EAClB,gCAAgC;EAChC,+BAA+B;EAC/B,0BAA0B;EAC1B,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,mBAAmB;AACrB;AACA,mDAAmD,eAAe,EAAE,gBAAgB,EAAE;AACtF;EACE,gCAAgC;EAChC,qBAAqB,EAAE,kBAAkB;EACzC,eAAe,EAAE,uBAAuB;AAC1C;AACA,iCAAiC,qBAAqB,EAAE,eAAe,EAAE,SAAS,EAAE;;AAEpF,eAAe,wBAAwB,EAAE;;AAEzC;;8EAE8E;;AAE9E;EACE,kBAAkB;EAClB,gCAAgC;EAChC,+BAA+B;EAC/B,0BAA0B;EAC1B,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,0CAA0C;AAC5C;AACA,yBAAyB,kCAAkC,EAAE,4BAA4B,EAAE;AAC3F,6BAA6B,YAAY,EAAE,UAAU,EAAE;;AAEvD;;8EAE8E;;AAE9E;EACE,2CAA2C;EAC3C,sBAAsB;EACtB,8BAA8B;EAC9B,uCAAuC;AACzC;AACA;EACE,eAAe;EACf,kFAAkF;EAClF,YAAY,EAAE,WAAW;EACzB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,WAAW,EAAE,YAAY;EACzB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,4BAA4B;EAC5B,eAAe;AACjB;AACA,kBAAkB,mBAAmB,EAAE,WAAW,EAAE,2BAA2B,EAAE,4BAA4B,EAAE;;AAE/G,6FAA6F;AAC7F;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB,EAAE,UAAU,EAAE,WAAW;EAC3C,UAAU,EAAE,YAAY,EAAE,gBAAgB;EAC1C,sBAAsB,EAAE,mBAAmB,EAAE,SAAS;AACxD;;AAEA,mBAAmB;AACnB;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;EACA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;;;;;;;;8EAQ8E;AAC9E;EACE;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B;;;;;;2EAMuE;IACvE,kBAAkB;IAClB,6BAA6B;IAC7B,iCAAiC;IACjC,uDAAuD;IACvD,wDAAwD;IACxD,6CAA6C;IAC7C,8CAA8C;IAC9C,oBAAoB;IACpB,qBAAqB;EACvB;EACA,sCAAsC,aAAa,EAAE;EACrD;IACE,wBAAwB;IACxB,yBAAyB;IACzB,wBAAwB;EAC1B;AACF;;AAEA;;8EAE8E;;AAE9E;EACE,+BAA+B,uBAAuB,EAAE,6BAA6B,EAAE,8BAA8B,EAAE;EACvH,iDAAiD,uBAAuB,EAAE,2BAA2B,EAAE;EACvG,gDAAgD,uBAAuB,EAAE;EACzE,mEAAmE,uBAAuB,EAAE,2BAA2B,EAAE;EACzH,eAAe,gCAAgC,EAAE;EACjD,kBAAkB,6BAA6B,EAAE;EACjD,2BAA2B,gBAAgB,EAAE,wBAAwB,EAAE;EACvE,mCAAmC,sBAAsB,EAAE;EAC3D,eAAe,+BAA+B,EAAE;EAChD,kBAAkB,mBAAmB,EAAE;EACvC,eAAe,eAAe,EAAE;EAChC,2BAA2B,kBAAkB,EAAE;EAC/C,iBAAiB,iBAAiB,EAAE,kBAAkB,EAAE;EACxD,oBAAoB,kBAAkB,EAAE;EACxC,kBAAkB,kBAAkB,EAAE;EACtC,yCAAyC,kBAAkB,EAAE;EAC7D,6BAA6B,aAAa,EAAE;EAC5C,eAAe,aAAa,EAAE;EAC9B,uBAAuB,sBAAsB,EAAE,SAAS,EAAE;EAC1D,2BAA2B,sBAAsB,EAAE;AACrD;;AAEA;;8EAE8E;;AAE9E;;0CAE0C,aAAa,EAAE","sourcesContent":["/* =========================================================================\n   Clametis Pharma — Design System v3 (Professional / Premium)\n   Loaded AFTER App.css so these tokens win. Aggressively overrides the\n   template's legacy hero/section/banner rules so the layout stays sane.\n   ========================================================================= */\n\n:root {\n  /* Brand */\n  --brand-primary: #008BB1;\n  --brand-primary-hover: #00A8D4;\n  --brand-primary-pressed: #00728F;\n  --brand-primary-soft: #E6F5F9;\n  --brand-primary-tint: #F4FAFC;\n  --brand-secondary: #F17732;\n  --brand-secondary-hover: #F58C4F;\n  --brand-secondary-soft: #FDECE1;\n  --brand-dark: #0B2536;\n  --brand-dark-2: #0F3145;\n\n  --grad-brand: linear-gradient(135deg, #00A8D4 0%, #007A9C 100%);\n  --grad-brand-soft: linear-gradient(135deg, #E6F5F9 0%, #F4FAFC 100%);\n  --grad-hero-bg: radial-gradient(1200px 800px at 90% -10%, rgba(0, 168, 212, 0.14), transparent 60%),\n                  radial-gradient(900px 600px at -10% 110%, rgba(241, 119, 50, 0.08), transparent 60%),\n                  linear-gradient(180deg, #FCFDFE 0%, #F4FAFC 100%);\n\n  /* Neutrals — cool grey, editorial */\n  --ink-950: #0A1220;\n  --ink-900: #101A2C;\n  --ink-800: #1B2740;\n  --ink-700: #2C3A55;\n  --ink-600: #495267;\n  --ink-500: #6B7385;\n  --ink-400: #96A0B4;\n  --ink-300: #C4CDDD;\n  --ink-200: #E4EAF3;\n  --ink-100: #F3F6FB;\n  --ink-50:  #FAFBFD;\n  --surface: #FFFFFF;\n  --surface-2: #F7FAFC;\n\n  /* Radius */\n  --radius-xs: 6px;\n  --radius-sm: 10px;\n  --radius-md: 14px;\n  --radius-lg: 20px;\n  --radius-xl: 28px;\n  --radius-2xl: 36px;\n  --radius-pill: 999px;\n\n  /* Shadow */\n  --shadow-xs: 0 1px 2px rgba(11, 37, 54, 0.06);\n  --shadow-sm: 0 4px 12px rgba(11, 37, 54, 0.06), 0 1px 2px rgba(11, 37, 54, 0.04);\n  --shadow-md: 0 12px 32px rgba(11, 37, 54, 0.08), 0 2px 6px rgba(11, 37, 54, 0.04);\n  --shadow-lg: 0 24px 60px rgba(11, 37, 54, 0.12), 0 4px 12px rgba(11, 37, 54, 0.05);\n  --shadow-xl: 0 40px 80px rgba(11, 37, 54, 0.18);\n  --shadow-cta: 0 12px 28px rgba(0, 139, 177, 0.28), 0 2px 6px rgba(0, 139, 177, 0.16);\n  --shadow-cta-hover: 0 16px 36px rgba(0, 139, 177, 0.36), 0 4px 12px rgba(0, 139, 177, 0.22);\n  --shadow-cta-secondary: 0 12px 28px rgba(241, 119, 50, 0.28), 0 2px 6px rgba(241, 119, 50, 0.16);\n\n  /* Motion */\n  --ease-out: cubic-bezier(0.16, 1, 0.3, 1);\n  --dur-fast: 150ms;\n  --dur: 250ms;\n  --dur-slow: 400ms;\n\n  /* Typography — Poppins throughout (body/ui/display); italic weight stands in\n     for the old serif-accent role so <em> emphasis still reads as a distinct touch. */\n  --font-sans: \"Poppins\", system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  --font-display: \"Poppins\", system-ui, -apple-system, sans-serif;\n  --font-serif: \"Poppins\", system-ui, -apple-system, sans-serif;\n\n  --fs-hero: clamp(2.5rem, 3.6vw + 1rem, 4rem);\n  --fs-display: clamp(2rem, 2.6vw + 1rem, 3.25rem);\n  --fs-h1: clamp(1.875rem, 2vw + 1rem, 2.75rem);\n  --fs-h2: clamp(1.625rem, 1.2vw + 1rem, 2.25rem);\n  --fs-h3: clamp(1.25rem, 0.5vw + 1rem, 1.5rem);\n  --fs-h4: 1.25rem;\n  --fs-h5: 1.125rem;\n  --fs-body: 1rem;\n  --fs-body-lg: 1.0625rem;\n  --fs-body-sm: 0.9375rem;\n  --fs-caption: 0.8125rem;\n  --fs-eyebrow: 0.75rem;\n\n  --container-w: 1280px;\n  --container-pad: 24px;\n\n  /* Bootstrap overrides */\n  --bs-primary: #008BB1;\n  --bs-primary-rgb: 0, 139, 177;\n  --bs-link-color: #008BB1;\n  --bs-link-color-rgb: 0, 139, 177;\n  --bs-link-hover-color: #00728F;\n  --bs-link-hover-color-rgb: 0, 114, 143;\n  --bs-body-color: #495267;\n  --bs-body-color-rgb: 73, 82, 103;\n  --bs-heading-color: #101A2C;\n  --bs-body-font-family: var(--font-sans);\n  --bs-body-font-weight: 500;\n  --bs-body-line-height: 1.6;\n}\n\n/* =========================================================================\n   NEUTRALIZE TEMPLATE HERO — old App.css has broken rules that force\n   height: 1085px and absolutely-position .inner-content off-canvas. Kill.\n   ========================================================================= */\n\n.main-banner {\n  height: auto !important;\n  min-height: 0 !important;\n  padding: 152px 0 108px !important;\n  background:\n    url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='28'%3E%3Ccircle cx='1.5' cy='1.5' r='1.5' fill='%23008BB1' fill-opacity='0.16'/%3E%3C/svg%3E\"),\n    var(--grad-hero-bg) !important;\n  background-repeat: repeat, no-repeat !important;\n  background-position: center, center !important;\n  background-size: 28px 28px, cover !important;\n  position: relative !important;\n  overflow: hidden !important;\n  z-index: 1 !important;\n  display: block !important;\n}\n.main-banner::before,\n.main-banner::after,\n.main-banner:before,\n.main-banner:after {\n  content: none !important;\n  display: none !important;\n  background: none !important;\n}\n\n/* The template forces .inner-content absolute-centered — undo entirely.\n   Keep .container's own Bootstrap max-width + auto margins working. */\n.main-banner .inner-content {\n  position: static !important;\n  top: auto !important;\n  left: auto !important;\n  right: auto !important;\n  bottom: auto !important;\n  transform: none !important;\n  z-index: 2;\n}\n\n.main-banner h1,\n.main-banner .h1 {\n  font-family: var(--font-display) !important;\n  font-weight: 700 !important;\n  font-size: var(--fs-hero) !important;\n  color: var(--ink-900) !important;\n  line-height: 1.06 !important;\n  letter-spacing: -0.035em !important;\n  margin: 0 0 24px !important;\n  padding: 0 !important;\n  background: none !important;\n  background-image: none !important;\n}\n.main-banner h1 em {\n  font-family: var(--font-serif) !important;\n  font-weight: 400 !important;\n  font-style: italic !important;\n  color: var(--brand-primary) !important;\n  letter-spacing: -0.02em !important;\n}\n\n/* Hero eyebrow badge — pill chip with icon-in-circle */\n.main-banner .hero-badges {\n  display: inline-flex !important;\n  align-items: center;\n  gap: 8px;\n  background: var(--surface);\n  border: 1px solid var(--ink-200);\n  border-radius: var(--radius-pill);\n  padding: 6px 16px 6px 6px;\n  margin-bottom: 20px;\n  box-shadow: var(--shadow-xs);\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ink-700);\n  letter-spacing: 0.01em;\n}\n.main-banner .hero-badges .dot {\n  width: 26px;\n  height: 26px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: var(--brand-primary-soft);\n  color: var(--brand-primary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Floating trust chip overlapping the hero photo — premium SaaS touch */\n.main-banner .hero-float-chip {\n  position: absolute;\n  left: -20px;\n  bottom: 28px;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: var(--surface);\n  border-radius: var(--radius-lg);\n  padding: 14px 18px;\n  box-shadow: var(--shadow-lg);\n  max-width: 230px;\n}\n.main-banner .hero-float-chip .icon {\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: var(--brand-secondary-soft);\n  color: var(--brand-secondary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.main-banner .hero-float-chip .label {\n  font-size: 11px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--ink-500);\n  font-weight: 600;\n  line-height: 1.3;\n}\n.main-banner .hero-float-chip .value {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--ink-900);\n  line-height: 1.3;\n}\n@media (max-width: 991px) {\n  .main-banner .hero-float-chip { left: 12px; bottom: -20px; }\n}\n@media (max-width: 575px) {\n  .main-banner .hero-float-chip { display: none; }\n}\n\n.main-banner .banner-img {\n  position: relative !important;\n  animation: none !important;\n  -webkit-animation: none !important;\n  margin: 0 !important;\n  padding: 20px !important;\n  display: block !important;\n}\n.main-banner .banner-img::before {\n  content: \"\" !important;\n  display: block !important;\n  position: absolute !important;\n  inset: 24px !important;\n  background: var(--grad-brand) !important;\n  border-radius: var(--radius-2xl) !important;\n  transform: rotate(-4deg) !important;\n  z-index: 0 !important;\n  box-shadow: var(--shadow-lg) !important;\n}\n.main-banner .banner-img img {\n  position: relative !important;\n  z-index: 1 !important;\n  border-radius: var(--radius-2xl) !important;\n  box-shadow: var(--shadow-lg) !important;\n  background: #fff !important;\n  width: 100% !important;\n  height: auto !important;\n  display: block !important;\n}\n.main-banner .title-ext {\n  background: none !important;\n  background-image: none !important;\n  margin: 0 0 16px !important;\n  padding: 0 !important;\n  font-size: var(--fs-eyebrow) !important;\n  color: var(--brand-primary) !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.14em !important;\n  font-weight: 600 !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 10px !important;\n}\n.main-banner .pt-img1,\n.main-banner .pt-img2,\n.main-banner .pt-img3,\n.main-banner .pt-img4,\n.main-banner .pt-img5 { display: none !important; }\n\n/* Hero stats — 3 columns, dividers between, editorial serif numerals */\n.main-banner .hero-stats {\n  display: grid !important;\n  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n  gap: 0 !important;\n  border-top: 1px solid var(--ink-200) !important;\n  max-width: 560px !important;\n  margin: 32px 0 0 !important;\n  padding: 24px 0 0 !important;\n}\n.main-banner .hero-stats > li {\n  padding: 0 20px !important;\n  border-left: 1px solid var(--ink-200);\n}\n.main-banner .hero-stats > li:first-child {\n  padding-left: 0 !important;\n  border-left: none;\n}\n.main-banner .hero-stats > li:last-child {\n  padding-right: 0 !important;\n}\n.main-banner .hero-stat-value {\n  font-family: var(--font-serif) !important;\n  font-weight: 400 !important;\n  font-size: 2.25rem !important;\n  line-height: 1 !important;\n  color: var(--ink-900) !important;\n  letter-spacing: -0.02em !important;\n  margin-bottom: 6px !important;\n}\n.main-banner .hero-stat-label {\n  font-family: var(--font-sans) !important;\n  font-size: 11px !important;\n  letter-spacing: 0.12em !important;\n  text-transform: uppercase !important;\n  color: var(--ink-500) !important;\n  font-weight: 600 !important;\n  line-height: 1.4 !important;\n}\n@media (max-width: 480px) {\n  .main-banner .hero-stat-value { font-size: 1.75rem !important; }\n  .main-banner .hero-stats > li { padding: 0 12px !important; }\n}\n\n/* =========================================================================\n   Global body & type\n   ========================================================================= */\n\nhtml { -webkit-text-size-adjust: 100%; }\n\nbody {\n  color: var(--ink-600);\n  background: var(--surface);\n  font-family: var(--font-sans);\n  font-weight: 500;\n  font-feature-settings: \"cv11\", \"ss01\", \"ss02\";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n  line-height: 1.6;\n  font-size: var(--fs-body);\n}\n\nh1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {\n  color: var(--ink-900);\n  font-family: var(--font-display);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.3;\n  margin-bottom: 0.5em;\n}\nh1, .h1 { font-size: var(--fs-h1); letter-spacing: -0.03em; }\nh2, .h2 { font-size: var(--fs-h2); letter-spacing: -0.025em; }\nh3, .h3 { font-size: var(--fs-h3); }\nh4, .h4 { font-size: var(--fs-h4); }\nh5, .h5 { font-size: var(--fs-h5); }\n\np { color: var(--ink-600); line-height: 1.65; }\n\nh1 em, h2 em, h3 em, h4 em, .h1 em, .h2 em, .h3 em {\n  font-family: var(--font-serif);\n  font-weight: 400;\n  font-style: italic;\n  color: var(--brand-primary);\n  letter-spacing: -0.02em;\n}\n\n.serif { font-family: var(--font-serif); font-weight: 400; letter-spacing: -0.01em; }\n.italic-serif { font-family: var(--font-serif); font-style: italic; font-weight: 400; }\n\n.eyebrow, .title-ext {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-family: var(--font-sans);\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  font-weight: 600;\n  font-size: var(--fs-eyebrow);\n  color: var(--brand-primary);\n  margin-bottom: 16px;\n}\n.eyebrow::before, .title-ext::before {\n  content: \"\";\n  width: 28px;\n  height: 1.5px;\n  background: currentColor;\n  border-radius: 2px;\n}\n.title-ext.text-secondary,\n.eyebrow.text-secondary { color: var(--brand-secondary) !important; }\n\n.lede {\n  font-size: var(--fs-body-lg);\n  color: var(--ink-500);\n  line-height: 1.7;\n  max-width: 62ch;\n}\n\n/* Focus */\n:focus { outline: none; }\n:focus-visible {\n  outline: 2px solid var(--brand-primary);\n  outline-offset: 3px;\n  border-radius: 6px;\n}\na { color: var(--brand-primary); text-decoration: none; transition: color var(--dur) var(--ease-out); }\na:hover { color: var(--brand-primary-hover); }\na, button, [role=\"button\"] {\n  transition: color var(--dur) var(--ease-out),\n              background-color var(--dur) var(--ease-out),\n              box-shadow var(--dur) var(--ease-out),\n              border-color var(--dur) var(--ease-out),\n              transform var(--dur) var(--ease-out);\n}\n\n/* =========================================================================\n   Container + section rhythm\n   ========================================================================= */\n\n.container {\n  padding-left: var(--container-pad) !important;\n  padding-right: var(--container-pad) !important;\n  margin-left: auto !important;\n  margin-right: auto !important;\n  width: 100% !important;\n  box-sizing: border-box !important;\n}\n.container-fluid {\n  padding-left: var(--container-pad);\n  padding-right: var(--container-pad);\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n}\n@media (min-width: 576px)  { .container { max-width: 540px !important; } }\n@media (min-width: 768px)  { .container { max-width: 720px !important; } }\n@media (min-width: 992px)  { .container { max-width: 960px !important; } }\n@media (min-width: 1200px) { .container { max-width: 1200px !important; } }\n@media (min-width: 1400px) { .container { max-width: 1360px !important; } }\n@media (min-width: 1600px) { .container { max-width: 1440px !important; } }\n\nsection, .section-area { position: relative; }\n.section-sp1, .section-sp2, .section-sp3, .section-sp {\n  padding-top: 72px;\n  padding-bottom: 72px;\n}\n@media (min-width: 992px) {\n  .section-sp1, .section-sp2, .section-sp3, .section-sp {\n    padding-top: 120px;\n    padding-bottom: 120px;\n  }\n}\n.section-tint { background: var(--surface-2); }\n/* Two tinted sections back-to-back read as one band — collapse the doubled padding\n   between them so it doesn't look like an empty gap floating inside a single color. */\n.section-tint + .section-tint {\n  padding-top: 56px !important;\n}\n.section-brand-soft { background: var(--grad-brand-soft); }\n\n/* Home + About + Medicine + Blog + Quality + Contact pages — every section\n   on these pages carried the same 120px desktop / 72px mobile padding as\n   the rest of the site, which read as a lot of dead space stacked between\n   short-content sections. Tighten just these pages rather than the shared\n   default other pages still rely on. */\n.home-page .section-sp1, .home-page .section-sp2, .home-page .section-sp3, .home-page .section-sp,\n.about-page .section-sp1, .about-page .section-sp2, .about-page .section-sp3, .about-page .section-sp,\n.medicine-page .section-sp1, .medicine-page .section-sp2, .medicine-page .section-sp3, .medicine-page .section-sp,\n.blog-page .section-sp1, .blog-page .section-sp2, .blog-page .section-sp3, .blog-page .section-sp,\n.quality-page .section-sp1, .quality-page .section-sp2, .quality-page .section-sp3, .quality-page .section-sp,\n.contact-page .section-sp1, .contact-page .section-sp2, .contact-page .section-sp3, .contact-page .section-sp {\n  padding-top: 48px;\n  padding-bottom: 48px;\n}\n@media (min-width: 992px) {\n  .home-page .section-sp1, .home-page .section-sp2, .home-page .section-sp3, .home-page .section-sp,\n  .about-page .section-sp1, .about-page .section-sp2, .about-page .section-sp3, .about-page .section-sp,\n  .medicine-page .section-sp1, .medicine-page .section-sp2, .medicine-page .section-sp3, .medicine-page .section-sp,\n  .blog-page .section-sp1, .blog-page .section-sp2, .blog-page .section-sp3, .blog-page .section-sp,\n  .quality-page .section-sp1, .quality-page .section-sp2, .quality-page .section-sp3, .quality-page .section-sp,\n  .contact-page .section-sp1, .contact-page .section-sp2, .contact-page .section-sp3, .contact-page .section-sp {\n    padding-top: 72px;\n    padding-bottom: 72px;\n  }\n}\n.home-page .section-tint + .section-tint,\n.about-page .section-tint + .section-tint,\n.medicine-page .section-tint + .section-tint,\n.blog-page .section-tint + .section-tint,\n.quality-page .section-tint + .section-tint,\n.contact-page .section-tint + .section-tint {\n  padding-top: 32px !important;\n}\n.home-page .about-area {\n  padding: 56px 0 !important;\n}\n\n/* =========================================================================\n   Header — permanently fixed to the viewport top, driven entirely by our\n   own `stuck` React state (see header.jsx). This used to run through\n   react-stickynode, a legacy library that tracked scroll position with its\n   own independent, separately-throttled state machine — parallel to (and\n   sometimes briefly out of sync with) our own scroll listener. The template\n   also had its own CSS rule making `.menu-bar` fix itself whenever\n   react-stickynode's `.active` class appeared, a SECOND independent\n   fixed-position layer on top of react-stickynode's JS-driven one. Two\n   independently-updating fixed layers occasionally disagreeing mid-scroll\n   is what caused the header to visibly hang onto a white background for a\n   moment after scrolling back to the top. Removing react-stickynode\n   removes that whole class of bug — position is now driven by exactly one\n   state, ours, always in sync with the background/shadow it pairs with.\n   `#main-content` carries matching top padding so page content isn't\n   hidden under the now-permanently-fixed bar (see further down). */\n\n.header,\n.header.header-transparent,\n.header.rs-nav {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  width: 100% !important;\n  z-index: 1030 !important;\n  background: transparent !important;\n  /* Force the fixed header onto its own stable GPU compositing layer,\n     isolated from the scrolling page content underneath. Without this,\n     some browser/GPU combinations can blend a fixed element with fast-\n     moving content behind it for a frame or two during a fast scroll —\n     visible as page content \"ghosting\" through the header — even though\n     nothing in our own CSS produces that state. This is the standard,\n     defensive fix for that class of compositing artifact. */\n  transform: translateZ(0);\n  will-change: transform;\n}\n.header .sticky-header {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n/* The visible header band is .menu-bar — style it (bg + shadow + transition).\n   At top: fully transparent, no tint at all, so it's unambiguous. On scroll:\n   solid white with a shadow. */\n.menu-bar,\n.header-transparent .menu-bar,\n.header .menu-bar,\n.rs-nav .menu-bar {\n  position: static !important;\n  background: transparent !important;\n  -webkit-backdrop-filter: none !important;\n  backdrop-filter: none !important;\n  padding: 0 !important;\n  width: 100% !important;\n  height: auto !important;\n  border-bottom: 1px solid transparent !important;\n  box-shadow: none !important;\n  z-index: 1030 !important;\n  /* No transition, on purpose: a fade between transparent and solid white\n     means there's a window where background-color is some intermediate\n     rgba(255,255,255,X) — genuinely translucent, with page content visibly\n     showing through the nav bar. Caught on video/screenshot that reads as\n     a rendering glitch, not a nice fade. Snapping instantly means there is\n     never a partial state to see. */\n  transition: none !important;\n}\n/* Fully transparent at top over the hero; solid white with shadow when scrolled */\n.header.is-stuck .menu-bar,\n.rs-nav.is-stuck .menu-bar {\n  background: #ffffff !important;\n  border-bottom-color: var(--ink-200) !important;\n  box-shadow: 0 6px 24px rgba(11, 37, 54, 0.08) !important;\n}\n/* Menu bar is a relatively-positioned strip. Logo + CTA float left/right,\n   nav is absolutely centered to the viewport so it's dead-center regardless\n   of logo or CTA widths. */\n.menu-bar > .container-fluid {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  position: relative !important;\n  gap: 24px !important;\n  height: 96px !important;\n  padding-left: 32px !important;\n  padding-right: 32px !important;\n  transition: height var(--dur) var(--ease-out) !important;\n}\n@media (min-width: 1200px) {\n  .menu-bar > .container-fluid {\n    padding-left: 48px !important;\n    padding-right: 48px !important;\n  }\n}\n/* Compact bar when scrolled */\n.header.is-stuck .menu-bar > .container-fluid {\n  height: 72px !important;\n}\n/* The header is always position:fixed now (see above), so it's out of\n   normal document flow — reserve the same space it used to occupy in-flow\n   at the top of the page, using its unstuck (tallest) height. Once the\n   user scrolls, the header overlapping page content is expected sticky-\n   header behaviour, not something to compensate for. */\n#main-content { padding-top: 96px; }\n@media (max-width: 767px) {\n  #main-content { padding-top: 72px; }\n}\n\n/* Logo — bigger by default, shrinks on scroll. Absolutely pinned to LEFT. */\n.header .menu-logo,\n.rs-nav .menu-logo {\n  display: inline-flex !important;\n  align-items: center !important;\n  float: none !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  width: auto !important;\n  height: auto !important;\n  min-width: 0 !important;\n  z-index: 2 !important;\n}\n@media (min-width: 1200px) {\n  .header .menu-logo,\n  .rs-nav .menu-logo {\n    position: absolute !important;\n    left: 48px !important;\n    top: 50% !important;\n    transform: translateY(-50%) !important;\n  }\n}\n.header .menu-logo a,\n.rs-nav .menu-logo a {\n  display: inline-flex !important;\n  align-items: center !important;\n  padding: 0 !important;\n  line-height: 0 !important;\n}\n.header .menu-logo img,\n.rs-nav .menu-logo img {\n  width: auto !important;\n  height: 56px !important;\n  max-height: 56px !important;\n  display: block !important;\n  transition: height var(--dur) var(--ease-out) !important;\n}\n.header.is-stuck .menu-logo img,\n.rs-nav.is-stuck .menu-logo img {\n  height: 40px !important;\n  max-height: 40px !important;\n}\n\n/* Kill template secondary-menu 105px height. Absolutely pinned to RIGHT. */\n.header .secondary-menu,\n.rs-nav .secondary-menu {\n  float: none !important;\n  height: auto !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  z-index: 2 !important;\n}\n@media (min-width: 1200px) {\n  .header .secondary-menu,\n  .rs-nav .secondary-menu {\n    position: absolute !important;\n    right: 48px !important;\n    top: 50% !important;\n    transform: translateY(-50%) !important;\n  }\n}\n.header .secondary-menu > ul,\n.rs-nav .secondary-menu > ul {\n  margin: 0 !important;\n  padding: 0 !important;\n  list-style: none !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 12px !important;\n}\n\n/* Menu links wrapper — absolutely centered to viewport, ignores flex flow */\n@media (min-width: 1200px) {\n  .header .menu-links,\n  .rs-nav .menu-links {\n    position: absolute !important;\n    left: 50% !important;\n    top: 50% !important;\n    transform: translate(-50%, -50%) !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    height: auto !important;\n    min-width: 0 !important;\n    float: none !important;\n    z-index: 1 !important;\n  }\n}\n.header .navbar-toggler,\n.rs-nav .navbar-toggler {\n  order: 4 !important;\n}\n\n/* Nav list — reset template float:right + margin-right:50px, then center */\n.header .menu-links .nav,\n.rs-nav .menu-links .nav {\n  float: none !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 4px !important;\n  list-style: none !important;\n}\n.header .menu-links .nav > li,\n.rs-nav .menu-links .nav > li {\n  margin: 0 !important;\n  padding: 0 !important;\n  border: none !important;\n  float: none !important;\n  width: auto !important;\n}\n\n/* Nav LINKS — kill template's 45px top/bottom padding */\n.header .menu-links .nav > li > a,\n.rs-nav .menu-links .nav > li > a,\n.nav.navbar-nav li a {\n  font-family: var(--font-sans) !important;\n  font-weight: 500 !important;\n  font-size: 14.5px !important;\n  color: var(--ink-800) !important;\n  letter-spacing: -0.005em !important;\n  padding: 10px 14px !important;\n  border-radius: var(--radius-pill) !important;\n  white-space: nowrap !important;\n  line-height: 1.2 !important;\n  border: none !important;\n  display: inline-block !important;\n  cursor: pointer;\n  transition: background var(--dur) var(--ease-out), color var(--dur) var(--ease-out) !important;\n}\n.header .menu-links .nav > li > a:hover,\n.rs-nav .menu-links .nav > li > a:hover,\n.nav.navbar-nav li a:hover {\n  color: var(--brand-primary) !important;\n  background: var(--brand-primary-soft) !important;\n}\n.header .menu-links .nav > li.active > a,\n.rs-nav .menu-links .nav > li.active > a,\n.nav.navbar-nav li.active > a {\n  color: var(--brand-primary) !important;\n  background: var(--brand-primary-soft) !important;\n}\n.secondary-menu .btn { font-size: 13.5px !important; padding: 10px 20px !important; }\n\n/* Drawer on < xl */\n@media (max-width: 1199.98px) {\n  .header .menu-bar .navbar-toggler,\n  .rs-nav .menu-bar .navbar-toggler { display: inline-flex !important; }\n  .header .secondary-menu,\n  .rs-nav .secondary-menu { display: none !important; }\n  .header #menuDropdown,\n  .rs-nav #menuDropdown {\n    display: none !important;\n    opacity: 0;\n    visibility: hidden;\n  }\n  .header #menuDropdown.show,\n  .rs-nav #menuDropdown.show {\n    display: flex !important;\n    opacity: 1;\n    visibility: visible;\n    position: fixed !important;\n    inset: 0 !important;\n    z-index: 1050 !important;\n    background: var(--surface) !important;\n    padding: 24px !important;\n    flex-direction: column !important;\n    align-items: stretch !important;\n    justify-content: flex-start !important;\n    overflow-y: auto !important;\n    width: 100% !important;\n    height: 100vh !important;\n    max-width: none !important;\n  }\n  #menuDropdown.show .nav.navbar-nav {\n    flex-direction: column !important;\n    gap: 6px !important;\n    width: 100% !important;\n    padding: 40px 0 !important;\n    align-items: stretch !important;\n  }\n  #menuDropdown.show .nav.navbar-nav li {\n    width: 100% !important;\n    display: block !important;\n  }\n  #menuDropdown.show .nav.navbar-nav li a {\n    display: block !important;\n    padding: 16px 20px !important;\n    font-size: 17px !important;\n    border-radius: 12px !important;\n    color: var(--ink-900) !important;\n    background: transparent !important;\n  }\n  #menuDropdown.show .nav.navbar-nav li a:hover {\n    background: var(--brand-primary-soft) !important;\n    color: var(--brand-primary) !important;\n  }\n  #menuDropdown.show .menu-logo {\n    display: block !important;\n    padding: 0 0 20px 0 !important;\n    border-bottom: 1px solid var(--ink-200) !important;\n  }\n  #menuDropdown.show .menu-close {\n    display: inline-flex !important;\n    position: absolute !important;\n    top: 28px !important;\n    right: 28px !important;\n    color: var(--ink-900) !important;\n    background: var(--surface);\n    border: 1px solid var(--ink-200);\n    border-radius: 12px;\n    width: 44px;\n    height: 44px;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n  }\n}\n@media (min-width: 1200px) {\n  .header .navbar-toggler,\n  .rs-nav .navbar-toggler { display: none !important; }\n  .menu-links .menu-logo,\n  .menu-links .menu-close { display: none !important; }\n}\n\n/* =========================================================================\n   Page hero / inner banners\n   ========================================================================= */\n\n.page-banner {\n  padding: 36px 0 20px !important;\n  background:\n    url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='28'%3E%3Ccircle cx='1.5' cy='1.5' r='1.5' fill='%23008BB1' fill-opacity='0.14'/%3E%3C/svg%3E\"),\n    var(--grad-hero-bg) !important;\n  background-repeat: repeat, no-repeat !important;\n  background-position: center, center !important;\n  background-size: 28px 28px, cover !important;\n  position: relative !important;\n  overflow: hidden !important;\n  height: auto !important;\n  min-height: 0 !important;\n  display: block !important;\n}\n.page-banner::before,\n.page-banner::after { content: none !important; display: none !important; }\n.page-banner .page-banner-entry {\n  position: relative;\n  z-index: 2;\n}\n.page-banner-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--surface);\n  border: 1px solid var(--ink-200);\n  border-radius: var(--radius-pill);\n  padding: 4px 12px;\n  margin-bottom: 8px;\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--brand-primary);\n  box-shadow: var(--shadow-xs);\n}\n.page-banner h1, .page-banner .h1 {\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: clamp(1.625rem, 1.8vw + 1rem, 2.5rem);\n  color: var(--ink-900);\n  letter-spacing: -0.03em;\n  margin-bottom: 6px;\n  text-transform: none !important;\n}\n.page-banner h1 em {\n  font-family: var(--font-serif);\n  font-style: italic;\n  font-weight: 400;\n  color: var(--brand-primary);\n}\n.page-banner-lede {\n  max-width: 560px;\n  margin: 0 auto 12px;\n  color: var(--ink-600);\n  font-size: 1rem;\n  line-height: 1.5;\n}\n.page-banner .breadcrumb {\n  display: inline-flex;\n  gap: 6px;\n  padding: 5px 12px;\n  background: var(--surface);\n  border: 1px solid var(--ink-200);\n  border-radius: var(--radius-pill);\n  box-shadow: var(--shadow-xs);\n  margin: 0 auto;\n  list-style: none;\n}\n.page-banner .breadcrumb li,\n.page-banner .breadcrumb-item {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--ink-500);\n}\n.page-banner .breadcrumb-item.active { color: var(--brand-primary); }\n.page-banner .breadcrumb-item + .breadcrumb-item::before {\n  content: \"/\" !important;\n  color: var(--ink-300);\n  padding: 0 6px;\n}\n.page-banner .breadcrumb a { color: var(--ink-700); }\n.page-banner .breadcrumb a:hover { color: var(--brand-primary); }\n.page-banner .pt-img1,\n.page-banner .pt-img2,\n.page-banner .pt-img3,\n.page-banner .pt-img4,\n.page-banner .pt-img5 { opacity: 0.25; }\n\n/* =========================================================================\n   Buttons\n   ========================================================================= */\n\n.btn {\n  --btn-py: 12px;\n  --btn-px: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: var(--btn-py) var(--btn-px);\n  border-radius: var(--radius-pill);\n  font-family: var(--font-sans);\n  font-weight: 600;\n  font-size: 14.5px;\n  letter-spacing: -0.005em;\n  line-height: 1.2;\n  border: 1.5px solid transparent;\n  cursor: pointer;\n  will-change: transform;\n}\n.btn-sm { --btn-py: 8px; --btn-px: 16px; font-size: 13px; }\n.btn-lg { --btn-py: 15px; --btn-px: 28px; font-size: 15.5px; }\n\n.btn-primary,\n.btn-primary.shadow {\n  background: var(--brand-primary) !important;\n  border-color: var(--brand-primary) !important;\n  color: #fff !important;\n  box-shadow: var(--shadow-cta) !important;\n}\n.btn-primary:hover,\n.btn-primary:focus-visible {\n  background: var(--brand-primary-hover) !important;\n  border-color: var(--brand-primary-hover) !important;\n  color: #fff !important;\n  box-shadow: var(--shadow-cta-hover) !important;\n  transform: translateY(-1px);\n}\n.btn-primary:active {\n  background: var(--brand-primary-pressed) !important;\n  transform: translateY(0);\n}\n.btn-primary.light {\n  background: var(--brand-primary-soft) !important;\n  color: var(--brand-primary) !important;\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n.btn-primary .btn-icon-bx { color: currentColor; }\n\n.btn-secondary,\n.btn-secondary.shadow {\n  background: var(--brand-secondary) !important;\n  border-color: var(--brand-secondary) !important;\n  color: #fff !important;\n  box-shadow: var(--shadow-cta-secondary) !important;\n}\n.btn-secondary:hover,\n.btn-secondary:focus-visible {\n  background: var(--brand-secondary-hover) !important;\n  border-color: var(--brand-secondary-hover) !important;\n  color: #fff !important;\n  transform: translateY(-1px);\n}\n.btn-secondary.light {\n  background: var(--brand-secondary-soft) !important;\n  color: var(--brand-secondary) !important;\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n.btn-outline-primary {\n  background: transparent !important;\n  border: 1.5px solid var(--ink-200) !important;\n  color: var(--ink-900) !important;\n  box-shadow: none !important;\n}\n.btn-outline-primary:hover,\n.btn-outline-primary:focus-visible {\n  background: var(--ink-900) !important;\n  border-color: var(--ink-900) !important;\n  color: #fff !important;\n  transform: translateY(-1px);\n}\n.btn .arrow-i { transition: transform var(--dur) var(--ease-out); }\n.btn:hover .arrow-i { transform: translateX(3px); }\n\n.text-primary { color: var(--brand-primary) !important; }\n.text-secondary { color: var(--brand-secondary) !important; }\n.bg-primary { background: var(--brand-primary) !important; }\n.bg-secondary { background: var(--brand-secondary) !important; }\n.bg-dark { background: var(--brand-dark) !important; }\n\n/* =========================================================================\n   Cards\n   ========================================================================= */\n\n.card,\n.blog-card,\n.medicine-card,\n.distributor-card,\n.premium-card {\n  background: var(--surface);\n  border: 1px solid var(--ink-200);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  transition: box-shadow var(--dur) var(--ease-out),\n              transform var(--dur) var(--ease-out),\n              border-color var(--dur) var(--ease-out);\n}\n.card:hover,\n.blog-card:hover,\n.medicine-card:hover,\n.distributor-card:hover,\n.premium-card:hover {\n  box-shadow: var(--shadow-md);\n  border-color: var(--ink-300);\n  transform: translateY(-3px);\n}\n\n/* Become-a-distributor \"Eligibility / Onboarding\" split — plain content on\n   the tinted section background instead of two matching boxed cards, with a\n   vertical hairline divider and a connecting line through the step numbers. */\n.onboarding-divider {\n  width: 1px;\n  height: 100%;\n  min-height: 280px;\n  background: var(--ink-200);\n}\n.onboarding-timeline > li { position: relative; padding-bottom: 28px; }\n.onboarding-timeline > li:last-child { padding-bottom: 0; }\n.onboarding-timeline > li::before {\n  content: \"\";\n  position: absolute;\n  left: 21px;\n  top: 44px;\n  bottom: 0;\n  width: 2px;\n  background: var(--ink-200);\n}\n.onboarding-timeline > li:last-child::before { content: none; }\n.onboarding-node { position: relative; z-index: 1; }\n\n/* About page — Mission / Vision split (plain text either side of a hairline,\n   not two boxed cards) and the Values spec-grid (bordered cells, no shadow,\n   no hover-lift — a quieter table treatment distinct from .therapy-card). */\n.mission-vision-col { padding: 8px 0; }\n.mission-vision-num {\n  display: block;\n  font-size: 2rem;\n  line-height: 1;\n  color: var(--ink-300);\n  margin-bottom: 12px;\n}\n@media (min-width: 992px) {\n  .mission-vision-col.is-start { padding-right: 48px; }\n  .mission-vision-col.is-end { padding-left: 48px; }\n}\n\n.value-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  border-top: 1px solid var(--ink-200);\n  border-left: 1px solid var(--ink-200);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n.value-grid-item {\n  padding: 32px;\n  border-right: 1px solid var(--ink-200);\n  border-bottom: 1px solid var(--ink-200);\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n.value-grid-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: var(--brand-primary-soft);\n  color: var(--brand-primary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.value-grid-item h3 { font-size: 17px; margin-bottom: 6px; letter-spacing: -0.01em; }\n.value-grid-item p { margin: 0; color: var(--ink-500); font-size: 14.5px; line-height: 1.6; }\n@media (max-width: 767px) {\n  .value-grid { grid-template-columns: 1fr; }\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  border-radius: var(--radius-pill);\n  background: var(--brand-primary-soft);\n  color: var(--brand-primary);\n  font-size: 13px;\n  font-weight: 600;\n}\n.chip-outline {\n  background: transparent;\n  border: 1px solid var(--ink-200);\n  color: var(--ink-700);\n}\n.chip-warm { background: var(--brand-secondary-soft); color: var(--brand-secondary); }\n\n/* =========================================================================\n   Trust strip\n   ========================================================================= */\n\n.trust-strip {\n  padding: 28px 0;\n  background: var(--surface);\n  border-top: 1px solid var(--ink-200);\n  border-bottom: 1px solid var(--ink-200);\n}\n.trust-strip .trust-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: var(--ink-700);\n  font-weight: 600;\n  font-size: 14px;\n  padding: 6px 0;\n}\n.trust-strip .trust-icon {\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: var(--brand-primary-soft);\n  color: var(--brand-primary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* =========================================================================\n   Section header\n   ========================================================================= */\n\n.section-head { text-align: center; margin-bottom: 56px; }\n.section-head.left { text-align: left; margin-bottom: 40px; }\n.section-head h2, .section-head .section-head-title {\n  margin: 0 0 12px;\n  font-family: var(--font-display);\n  font-weight: 700;\n  letter-spacing: -0.025em;\n}\n.section-head .lede { margin: 0 auto; }\n.section-head.left .lede { margin: 0; }\n\n/* =========================================================================\n   Therapy / value cards\n   ========================================================================= */\n\n.therapy-grid .therapy-card {\n  position: relative;\n  padding: 28px;\n  background: var(--surface);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--ink-200);\n  height: 100%;\n  display: block;\n  color: inherit;\n  overflow: hidden;\n  transition: transform var(--dur) var(--ease-out),\n              box-shadow var(--dur) var(--ease-out),\n              border-color var(--dur) var(--ease-out);\n  text-decoration: none;\n}\n.therapy-grid .therapy-card::after {\n  content: \"\";\n  position: absolute;\n  inset: auto -30% -60% auto;\n  width: 220px;\n  height: 220px;\n  background: var(--grad-brand);\n  opacity: 0;\n  border-radius: 50%;\n  filter: blur(40px);\n  transition: opacity var(--dur) var(--ease-out);\n  pointer-events: none;\n  z-index: 0;\n}\n.therapy-grid .therapy-card:hover {\n  border-color: transparent;\n  box-shadow: var(--shadow-lg);\n  transform: translateY(-6px);\n}\n.therapy-grid .therapy-card:hover::after { opacity: 0.10; }\n.therapy-grid .therapy-card > * { position: relative; z-index: 1; }\n\n.therapy-grid .therapy-icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  background: var(--brand-primary-soft);\n  color: var(--brand-primary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n  transition: background var(--dur) var(--ease-out), color var(--dur) var(--ease-out);\n}\n.therapy-grid .therapy-card:hover .therapy-icon {\n  background: var(--brand-primary);\n  color: #fff;\n}\n.therapy-grid .therapy-icon svg { width: 24px; height: 24px; }\n.therapy-grid .therapy-card h3 {\n  font-size: 19px;\n  margin-bottom: 8px;\n  letter-spacing: -0.01em;\n  color: var(--ink-900);\n}\n.therapy-grid .therapy-card p { color: var(--ink-500); margin: 0; font-size: 14.5px; line-height: 1.6; }\n.therapy-grid .therapy-card .card-arrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 16px;\n  color: var(--brand-primary);\n  font-weight: 600;\n  font-size: 13.5px;\n  opacity: 0;\n  transform: translateY(4px);\n  transition: opacity var(--dur) var(--ease-out), transform var(--dur) var(--ease-out);\n}\n.therapy-grid .therapy-card:hover .card-arrow {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* =========================================================================\n   Quality checklist — enumerated rows, not cards. Large faded index number,\n   icon, copy; divided by hairlines. Used on the Quality page's \"six checks\"\n   so it doesn't repeat the card-grid pattern already used elsewhere.\n   ========================================================================= */\n.quality-checklist {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-width: 900px;\n  margin-inline: auto;\n}\n.quality-checklist > li {\n  display: flex;\n  align-items: flex-start;\n  gap: 24px;\n  padding: 28px 0;\n  border-bottom: 1px solid var(--ink-200);\n}\n.quality-checklist > li:first-child { padding-top: 0; }\n.quality-checklist > li:last-child { border-bottom: none; padding-bottom: 0; }\n.quality-checklist-num {\n  font-family: var(--font-serif);\n  font-size: 2rem;\n  line-height: 1;\n  color: var(--ink-300);\n  flex-shrink: 0;\n  width: 56px;\n  padding-top: 4px;\n}\n.quality-checklist-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: var(--brand-primary-soft);\n  color: var(--brand-primary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.quality-checklist-copy h3 { font-size: 18px; margin-bottom: 6px; letter-spacing: -0.01em; }\n.quality-checklist-copy p { color: var(--ink-500); margin: 0; font-size: 14.5px; line-height: 1.6; }\n@media (max-width: 575px) {\n  .quality-checklist > li { gap: 14px; }\n  .quality-checklist-num { width: 34px; font-size: 1.5rem; }\n}\n\n/* =========================================================================\n   Therapeutic areas — anchor stat panel + adjacent-areas list (rows, not\n   another card grid, since the quick-grid cards already live on the Home\n   page teaser).\n   ========================================================================= */\n#cardiology { scroll-margin-top: 96px; }\n.area-stat-panel {\n  height: 100%;\n  min-height: 280px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 40px;\n  border-radius: var(--radius-xl);\n  background: var(--grad-brand-soft);\n  box-shadow: var(--shadow-md);\n}\n.area-stat-icon {\n  width: 76px;\n  height: 76px;\n  border-radius: 20px;\n  background: var(--surface);\n  color: var(--brand-primary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n  box-shadow: var(--shadow-sm);\n}\n.area-stat-value {\n  font-family: var(--font-serif);\n  font-size: 44px;\n  color: var(--brand-primary);\n  line-height: 1;\n}\n.area-stat-panel p {\n  margin: 10px 0 0;\n  color: var(--ink-600);\n  max-width: 280px;\n}\n\n.area-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.area-list > li {\n  display: flex;\n  align-items: flex-start;\n  gap: 24px;\n  padding: 32px 0;\n  border-bottom: 1px solid var(--ink-200);\n  scroll-margin-top: 96px;\n}\n.area-list > li:first-child { padding-top: 0; }\n.area-list > li:last-child { border-bottom: none; padding-bottom: 0; }\n.area-list-icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  background: var(--brand-primary-soft);\n  color: var(--brand-primary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.area-list-copy h3 { font-size: 19px; margin-bottom: 6px; letter-spacing: -0.01em; }\n.area-list-copy p { color: var(--ink-500); margin: 0 0 14px; font-size: 14.5px; line-height: 1.6; }\n@media (max-width: 575px) {\n  .area-list > li { gap: 14px; }\n  .area-list-icon { width: 42px; height: 42px; }\n}\n\n/* =========================================================================\n   Stats strip\n   ========================================================================= */\n\n.stats-strip {\n  background: linear-gradient(135deg, var(--brand-dark) 0%, var(--brand-dark-2) 100%);\n  color: #fff;\n  padding: 72px 0;\n  position: relative;\n  overflow: hidden;\n}\n.stats-strip::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(600px 400px at 90% 10%, rgba(0, 168, 212, 0.20), transparent 60%),\n    radial-gradient(500px 300px at 10% 90%, rgba(241, 119, 50, 0.14), transparent 60%);\n  pointer-events: none;\n}\n.stats-strip .container { position: relative; z-index: 1; }\n.stats-strip .stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 0; }\n@media (max-width: 767px) { .stats-strip .stats-grid { grid-template-columns: repeat(2, 1fr); } }\n.stats-strip .stat { text-align: center; padding: 24px 12px; position: relative; }\n.stats-strip .stat + .stat::before {\n  content: \"\";\n  position: absolute;\n  top: 20%;\n  bottom: 20%;\n  left: 0;\n  width: 1px;\n  background: rgba(255, 255, 255, 0.12);\n}\n@media (max-width: 767px) {\n  .stats-strip .stat:nth-child(odd) + .stat::before { display: none; }\n}\n.stats-strip .stat-value {\n  font-family: var(--font-serif);\n  font-weight: 400;\n  font-size: clamp(2.5rem, 3.5vw, 3.5rem);\n  line-height: 1;\n  color: #fff;\n  letter-spacing: -0.025em;\n  margin-bottom: 12px;\n}\n.stats-strip .stat-value .unit {\n  font-family: var(--font-sans);\n  font-size: 0.4em;\n  vertical-align: super;\n  color: var(--brand-primary);\n  margin-left: 4px;\n  letter-spacing: 0;\n  font-weight: 600;\n}\n.stats-strip .stat-label {\n  color: rgba(255, 255, 255, 0.70);\n  font-size: 12px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n/* =========================================================================\n   Pre-footer CTA\n   ========================================================================= */\n\n.prefooter-cta {\n  position: relative;\n  background: linear-gradient(135deg, var(--brand-primary) 0%, var(--brand-primary-pressed) 100%);\n  color: #fff;\n  padding: 72px 40px;\n  border-radius: var(--radius-2xl);\n  margin: 96px 24px;\n  overflow: hidden;\n  box-shadow: var(--shadow-lg);\n}\n.prefooter-cta::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(400px 300px at 100% 0%, rgba(255, 255, 255, 0.14), transparent 60%),\n    radial-gradient(400px 300px at 0% 100%, rgba(0, 0, 0, 0.15), transparent 60%);\n  pointer-events: none;\n}\n.prefooter-cta .prefooter-inner { position: relative; z-index: 1; }\n.prefooter-cta h2 {\n  color: #fff;\n  font-family: var(--font-display);\n  font-size: var(--fs-h2);\n  letter-spacing: -0.025em;\n}\n.prefooter-cta h2 em {\n  font-family: var(--font-serif);\n  font-style: italic;\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.85);\n}\n.prefooter-cta p { color: rgba(255, 255, 255, 0.86); font-size: 1.0625rem; }\n.prefooter-cta .btn-primary {\n  background: #fff !important;\n  color: var(--brand-primary) !important;\n  border-color: #fff !important;\n  box-shadow: var(--shadow-md) !important;\n}\n.prefooter-cta .btn-primary:hover {\n  background: #F4FAFC !important;\n  color: var(--brand-primary-pressed) !important;\n}\n.prefooter-cta .btn-outline-primary {\n  border-color: rgba(255, 255, 255, 0.5) !important;\n  color: #fff !important;\n  background: transparent !important;\n}\n.prefooter-cta .btn-outline-primary:hover {\n  background: #fff !important;\n  color: var(--brand-primary) !important;\n  border-color: #fff !important;\n}\n\n/* =========================================================================\n   Testimonial\n   ========================================================================= */\n\n.testimonial-wraper .heading-bx h2 {\n  font-family: var(--font-display);\n  font-size: var(--fs-h1);\n  margin-bottom: 8px;\n}\n.testimonial-wraper .heading-bx h2 br { display: none; }\n.testimonial-bx {\n  position: relative;\n  background: var(--surface);\n  border-radius: var(--radius-xl);\n  padding: 44px 40px;\n  border: 1px solid var(--ink-200);\n  box-shadow: var(--shadow-md);\n}\n.testimonial-bx .quote-icon {\n  position: absolute;\n  top: -14px;\n  left: 32px;\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: var(--brand-primary);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: var(--shadow-cta);\n}\n.testimonial-bx .testimonial-content p {\n  font-family: var(--font-serif);\n  font-size: 1.35rem;\n  line-height: 1.5;\n  color: var(--ink-900);\n  letter-spacing: -0.01em;\n  font-style: italic;\n  font-weight: 400;\n  margin-bottom: 24px;\n}\n.testimonial-bx .client-info .name {\n  color: var(--ink-900);\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: 1.0625rem;\n  margin-bottom: 2px;\n}\n.testimonial-bx .client-info p {\n  color: var(--ink-500);\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.10em;\n  font-weight: 600;\n  margin: 0;\n}\n.testimonial-wraper .thumb-wraper {\n  position: relative;\n  min-height: 320px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.testimonial-wraper .thumb-wraper .overlay-image {\n  width: 180px !important;\n  height: 180px !important;\n  box-shadow: var(--shadow-lg) !important;\n  border: 4px solid #fff !important;\n}\n.testimonial-wraper .thumb-wraper .bg-img { opacity: 0.35; }\n.testimonial-wraper .thumb-wraper ul { padding-left: 0; list-style: none; }\n\n/* Single unified testimonial card — full container width like every other\n   card on the page, split internally into quote (left) + attribution (right)\n   with a divider, so it doesn't read as an undersized orphan block. */\n.testimonial-single-wrap {\n  width: 100%;\n}\n.testimonial-bx-unified {\n  /* The template's base .testimonial-bx (still applied alongside this class,\n     see testimonial.jsx) hardcodes height: 303px / min-height: 302px for\n     its own shorter single-line quote design. Our unified card holds a\n     longer quote plus a client-info row — on mobile, where both stack\n     vertically, that easily exceeds 303px and the info row was rendering\n     outside the card's own background. Let it size to its content. */\n  height: auto !important;\n  min-height: 0 !important;\n  display: flex;\n  align-items: stretch;\n  gap: 48px;\n  padding: 48px;\n  text-align: left;\n}\n.testimonial-bx-unified .testimonial-main {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n.testimonial-bx-unified .quote-icon {\n  position: static;\n  margin-bottom: 20px;\n}\n.testimonial-bx-unified .testimonial-content p {\n  font-size: 1.5rem;\n}\n.testimonial-bx-unified .client-info-col {\n  flex: 0 0 240px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 14px;\n  padding-left: 48px;\n  border-left: 1px solid var(--ink-200);\n}\n.testimonial-bx-unified .client-avatar {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid var(--brand-primary-soft);\n  flex-shrink: 0;\n}\n.testimonial-dots button {\n  width: 44px;\n  height: 44px;\n  padding: 0;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  background: transparent;\n  cursor: pointer;\n  transition: border-color var(--dur) var(--ease-out);\n}\n.testimonial-dots button.is-active { border-color: var(--brand-primary); }\n.testimonial-dots button img {\n  width: 36px;\n  height: 36px;\n  object-fit: cover;\n  border-radius: 50%;\n  display: block;\n  margin: 0 auto;\n}\n@media (max-width: 767px) {\n  .testimonial-bx-unified {\n    flex-direction: column;\n    padding: 32px 24px;\n    gap: 24px;\n  }\n  .testimonial-bx-unified .testimonial-content p { font-size: 1.25rem; }\n  .testimonial-bx-unified .client-info-col {\n    /* Base rule's `flex: 0 0 240px` sets WIDTH in the desktop row layout,\n       but .testimonial-bx-unified switches to flex-direction: column here —\n       that same flex-basis then forces a 240px HEIGHT instead, well past\n       what the avatar+name actually need, overflowing the card and getting\n       clipped. Reset to content-sized. */\n    flex: 0 0 auto;\n    flex-direction: row;\n    align-items: center;\n    border-left: none;\n    border-top: 1px solid var(--ink-200);\n    padding-left: 0;\n    padding-top: 24px;\n    width: 100%;\n  }\n}\n\n/* =========================================================================\n   Blog cards\n   ========================================================================= */\n\n.blog-card {\n  display: flex;\n  flex-direction: column;\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  background: var(--surface);\n  border: 1px solid var(--ink-200);\n  box-shadow: none;\n  transition: box-shadow var(--dur) var(--ease-out), transform var(--dur) var(--ease-out), border-color var(--dur) var(--ease-out);\n}\n.blog-card:hover { box-shadow: var(--shadow-md); border-color: var(--ink-300); transform: translateY(-3px); }\n.blog-card .post-media {\n  aspect-ratio: 16 / 10;\n  overflow: hidden;\n  background: var(--ink-100);\n}\n.blog-card .post-media img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform var(--dur-slow) var(--ease-out);\n}\n.blog-card:hover .post-media img { transform: scale(1.05); }\n.blog-card .post-info,\n.blog-card .info-bx { padding: 24px; }\n.blog-card .post-meta {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 12px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 20px;\n  color: var(--ink-500);\n  font-size: 13px;\n}\n.blog-card .post-meta li { display: inline-flex; align-items: center; gap: 6px; }\n.blog-card .post-title,\n.blog-card h3.post-title {\n  font-family: var(--font-display);\n  font-size: 19px;\n  margin-bottom: 16px;\n  color: var(--ink-900);\n  font-weight: 700;\n  letter-spacing: -0.015em;\n  line-height: 1.25;\n}\n.blog-card a.btn { align-self: flex-start; }\n\n/* Blog detail */\n.blog-detail-card {\n  border: 1px solid var(--ink-200);\n  border-radius: var(--radius-xl);\n  overflow: hidden;\n  background: var(--surface);\n}\n.blog-detail-card .post-media img { width: 100%; height: auto; }\n.blog-detail-card .info-bx { padding: 40px; }\n.blog-detail-card .post-title { font-size: var(--fs-h2); }\n.blog-detail-card p { font-size: 1.0625rem; line-height: 1.75; }\n\n.share-row {\n  display: flex; align-items: center; gap: 10px;\n  margin: 32px 0 0; flex-wrap: wrap;\n  padding-top: 24px;\n  border-top: 1px solid var(--ink-200);\n}\n.share-row .share-btn {\n  display: inline-flex; align-items: center; gap: 6px;\n  padding: 8px 16px; border-radius: var(--radius-pill);\n  border: 1px solid var(--ink-200);\n  color: var(--ink-700);\n  background: var(--surface);\n  font-size: 13px; font-weight: 600;\n  text-decoration: none;\n}\n.share-row .share-btn:hover {\n  border-color: var(--brand-primary);\n  color: var(--brand-primary);\n  background: var(--brand-primary-soft);\n}\n\n/* =========================================================================\n   Forms\n   ========================================================================= */\n\n.form-control,\n.custom-select .css-13cymwt-control,\n.custom-select .css-t3ipsp-control {\n  border: 1.5px solid var(--ink-200) !important;\n  border-radius: var(--radius-md) !important;\n  min-height: 52px !important;\n  padding: 12px 16px !important;\n  font-size: 15px !important;\n  font-weight: 500 !important;\n  color: var(--ink-800) !important;\n  background: var(--surface) !important;\n  font-family: var(--font-sans) !important;\n}\n.form-control::placeholder { color: var(--ink-400); }\n.form-control:focus {\n  border-color: var(--brand-primary) !important;\n  box-shadow: 0 0 0 4px rgba(0, 139, 177, 0.12) !important;\n  outline: none !important;\n}\n.form-control.error { border-color: #F72B50 !important; }\nlabel {\n  display: inline-block;\n  font-family: var(--font-sans);\n  font-weight: 600;\n  color: var(--ink-800);\n  margin-bottom: 8px;\n  font-size: 13px;\n  letter-spacing: -0.005em;\n}\ntextarea.form-control { min-height: 140px !important; padding: 14px 16px !important; }\n\n.form-wraper {\n  background: var(--surface);\n  padding: 32px;\n  border-radius: var(--radius-xl);\n  border: 1px solid var(--ink-200);\n  box-shadow: var(--shadow-md);\n}\n.appointment-form h3, .form-wraper > h3, .form-wraper .title {\n  font-family: var(--font-display);\n  font-size: 22px;\n  color: var(--ink-900);\n  margin-bottom: 20px;\n  letter-spacing: -0.015em;\n}\n\n/* =========================================================================\n   Product cards & search\n   ========================================================================= */\n\n/* Template gave every .services-block-three an always-on corner-bracket accent\n   in an off-brand blue (#03a9f5, not --brand-primary) via a nested div's\n   ::before/::after. It shows on medicine cards, distributor cards and the\n   brand filter tabs. Our own hover/active treatment on each of those already\n   communicates state, so kill the leftover brackets everywhere. */\n.services-block-three > div::before,\n.services-block-three > div::after {\n  content: none !important;\n  display: none !important;\n}\n\n.product-card-design {\n  padding: 24px;\n  border: 1px solid var(--ink-200);\n  border-radius: var(--radius-lg);\n  background: var(--surface);\n  transition: all var(--dur) var(--ease-out);\n  text-align: center;\n}\n.product-card-design:hover {\n  border-color: var(--brand-primary);\n  box-shadow: var(--shadow-lg);\n  transform: translateY(-4px);\n}\n.product-card-design img {\n  max-height: 180px;\n  object-fit: contain;\n  transition: transform var(--dur) var(--ease-out);\n}\n.product-card-design:hover img { transform: scale(1.03); }\n.product-card-design h3 {\n  font-family: var(--font-display);\n  font-size: 17px;\n  margin-top: 16px;\n  margin-bottom: 4px;\n  color: var(--ink-900);\n  letter-spacing: -0.01em;\n}\n.product-card-design p { font-size: 13px; color: var(--ink-500); margin: 0; }\n\n.product-searchbar {\n  position: relative;\n  max-width: 560px;\n  margin: 0 auto 32px !important;\n}\n.product-searchbar input {\n  width: 100%;\n  height: 56px;\n  border-radius: var(--radius-pill);\n  background: var(--surface);\n  border: 1.5px solid var(--ink-200);\n  padding: 0 24px 0 52px;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--ink-800);\n  transition: all var(--dur) var(--ease-out);\n  box-shadow: var(--shadow-xs);\n  font-family: var(--font-sans);\n}\n.product-searchbar input:focus {\n  outline: none;\n  border-color: var(--brand-primary);\n  box-shadow: 0 0 0 4px rgba(0, 139, 177, 0.10), var(--shadow-sm);\n}\n.product-searchbar .search-icon {\n  position: absolute;\n  left: 18px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--ink-400);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n\n/* Brand filter tabs — replaces the removed corner-bracket accent with a\n   tinted-background active state, matching the \"selected\" language used\n   elsewhere (header nav, chips). */\n.brand-filter-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 20px 28px;\n}\n.product-tabs {\n  width: auto;\n  height: auto;\n  cursor: pointer;\n  text-align: center;\n}\n.product-tabs .tab-icon {\n  width: 84px;\n  height: 84px;\n  border-radius: var(--radius-lg);\n  border: 1.5px solid var(--ink-200);\n  background: var(--surface);\n  margin: 0 auto;\n  transition: all var(--dur) var(--ease-out);\n}\n.product-tabs .tab-icon img { height: 36px; max-width: 60px; }\n.product-tabs p {\n  margin: 10px 0 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ink-600);\n  text-transform: none !important;\n  transition: color var(--dur) var(--ease-out);\n}\n.product-tabs:hover .tab-icon { border-color: var(--brand-primary); box-shadow: var(--shadow-sm); }\n.product-tabs.active .tab-icon {\n  border-color: var(--brand-primary);\n  background: var(--brand-primary-soft);\n  box-shadow: var(--shadow-sm);\n}\n.product-tabs.active p { color: var(--brand-primary); }\n\n.medicine-results-row {\n  padding: 24px 0;\n  margin-bottom: 8px;\n  border-top: 1px solid var(--ink-200);\n  border-bottom: 1px solid var(--ink-200);\n}\n.medicine-results-row .text-muted { font-size: 14px; font-weight: 500; }\n\n/* =========================================================================\n   Pagination — shared by Blogs and Medicine listings. Bootstrap's default\n   .pagination/.page-link had no brand styling applied anywhere, so it was\n   rendering as flat, mismatched boxes.\n   ========================================================================= */\n.pagination {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 8px;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n.pagination .page-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 44px;\n  height: 44px;\n  padding: 0 18px;\n  border-radius: var(--radius-pill) !important;\n  border: 1.5px solid var(--ink-200);\n  background: var(--surface);\n  color: var(--ink-700);\n  font-weight: 600;\n  font-size: 14px;\n  transition: all var(--dur) var(--ease-out);\n  cursor: pointer;\n}\n.pagination .page-item:first-child .page-link,\n.pagination .page-item:last-child .page-link {\n  width: auto !important;\n}\n.pagination .page-link:hover:not(:disabled) {\n  border-color: var(--brand-primary);\n  color: var(--brand-primary);\n  background: var(--brand-primary-soft);\n}\n.pagination .page-link.active {\n  background: var(--brand-primary);\n  border-color: var(--brand-primary);\n  color: #fff;\n  box-shadow: var(--shadow-sm);\n}\n.pagination .page-item.disabled .page-link {\n  opacity: 0.45;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n/* =========================================================================\n   Medicine detail\n   ========================================================================= */\n\n.product-img-container {\n  /* Template hardcodes height/min-height/max-height: 380px — a landscape\n     pack-shot doesn't fill that at any width, leaving a large dead gap\n     above/below the image inside the box (worst on mobile, where the\n     container is also full-width and the mismatch is most visible). Let\n     it hug the image + padding instead. */\n  height: auto !important;\n  min-height: 0 !important;\n  max-height: none !important;\n  background: var(--surface-2);\n  border: 1px solid var(--ink-200);\n  border-radius: var(--radius-xl);\n  padding: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.product-img-container img { max-height: 320px; }\n\n/* Clinical-highlight one-pager bundled per brand (see MedicineDetail.jsx) —\n   framed like a document rather than dropped in edge-to-edge. */\n.medicine-highlight-card {\n  border: 1px solid var(--ink-200);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n  background: var(--surface);\n}\n.medicine-highlight-card img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.product-detail-container h2,\n.product-detail-container h3.title {\n  font-family: var(--font-display);\n  font-size: var(--fs-h1);\n  margin-bottom: 8px;\n  letter-spacing: -0.025em;\n}\n/* Product spec sheet — plain label/value row divided by hairlines, not\n   boxed tiles, so the medicine detail page doesn't repeat the card pattern. */\n.product-spec-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0;\n  border-top: 1px solid var(--ink-200);\n  border-bottom: 1px solid var(--ink-200);\n}\n.product-spec-item {\n  flex: 1 1 25%;\n  min-width: 140px;\n  padding: 18px 20px 18px 0;\n  margin-right: 20px;\n  border-right: 1px solid var(--ink-200);\n}\n.product-spec-item:last-child { border-right: none; margin-right: 0; }\n.product-spec-row dt {\n  font-size: 11px;\n  color: var(--ink-500);\n  text-transform: uppercase;\n  letter-spacing: 0.10em;\n  font-weight: 600;\n  margin-bottom: 6px;\n}\n.product-spec-row dd {\n  font-family: var(--font-display);\n  font-size: 15px;\n  margin: 0;\n  color: var(--ink-900);\n  font-weight: 600;\n}\n@media (max-width: 767px) {\n  .product-spec-item {\n    flex: 1 1 45%;\n    border-right: none;\n    border-bottom: 1px solid var(--ink-200);\n    padding: 14px 0;\n    margin-right: 0;\n  }\n  .product-spec-item:nth-child(odd) { padding-right: 16px; }\n}\n\n.rx-notice {\n  border-left: 3px solid var(--brand-secondary);\n  background: var(--brand-secondary-soft);\n  padding: 16px 20px;\n  border-radius: 0 var(--radius-md) var(--radius-md) 0;\n  color: var(--ink-800);\n  font-size: 14px;\n  margin: 24px 0;\n}\n.rx-notice strong { color: var(--brand-secondary); font-weight: 700; }\n.custom-section-bg { background: var(--surface-2); }\n\n/* =========================================================================\n   Distributor cards + search/filter bar\n   ========================================================================= */\n\n.distributor-card, .services-block-three {\n  padding: 24px !important;\n  border: 1px solid var(--ink-200);\n  border-radius: var(--radius-lg);\n  background: var(--surface);\n  height: 100%;\n  transition: all var(--dur) var(--ease-out);\n}\n.distributor-card:hover, .services-block-three:hover {\n  border-color: var(--brand-primary);\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n}\n.distributor-card h3, .services-block-three h3 {\n  font-family: var(--font-display);\n  font-size: 17px;\n  margin-bottom: 14px;\n  color: var(--ink-900);\n  letter-spacing: -0.01em;\n}\n.distributor-card p, .services-block-three p {\n  color: var(--ink-500);\n  font-size: 14px;\n  line-height: 1.6;\n}\n.distributor-card-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-top: 10px;\n}\n.distributor-card-icon {\n  width: 26px;\n  height: 26px;\n  border-radius: 8px;\n  background: var(--brand-primary-soft);\n  color: var(--brand-primary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n.distributor-card-row p { margin: 0; font-size: 13.5px; line-height: 1.5; }\n.distributor-card-row a {\n  font-size: 13.5px;\n  color: var(--brand-primary);\n  font-weight: 600;\n  text-decoration: none;\n}\n.distributor-card-row a:hover { text-decoration: underline; }\n\n/* Unified filter bar — state/city (react-select) and search used to sit in\n   mismatched boxes (a tinted padded wrapper around the selects, a plain\n   bordered input for search). One bordered panel, one background everywhere. */\n.distributor-filter-bar {\n  background: var(--surface);\n  border: 1px solid var(--ink-200);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  padding: 24px;\n  margin-bottom: 40px;\n}\n.custom-select {\n  background: transparent !important;\n  padding: 0 !important;\n  border-radius: 0 !important;\n}\n.distributor-search { position: relative; }\n.distributor-search .form-control { padding-left: 44px !important; }\n.distributor-search .search-icon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--ink-400);\n  display: inline-flex;\n  pointer-events: none;\n}\n\n/* =========================================================================\n   FAQ\n   ========================================================================= */\n\n.faq-list { max-width: 820px; margin: 0 auto; }\n.faq-list .faq-item {\n  border: 1px solid var(--ink-200);\n  border-radius: var(--radius-md);\n  margin-bottom: 12px;\n  background: var(--surface);\n  overflow: hidden;\n  transition: border-color var(--dur) var(--ease-out), box-shadow var(--dur) var(--ease-out);\n}\n.faq-list .faq-item[open] { border-color: var(--brand-primary); box-shadow: var(--shadow-sm); }\n.faq-list .faq-item summary {\n  padding: 20px 24px;\n  cursor: pointer;\n  font-family: var(--font-display);\n  font-weight: 600;\n  color: var(--ink-900);\n  list-style: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  font-size: 16px;\n  letter-spacing: -0.005em;\n}\n.faq-list .faq-item summary::-webkit-details-marker { display: none; }\n.faq-list .faq-item summary::after {\n  content: \"\";\n  width: 28px; height: 28px;\n  border-radius: 50%;\n  background: var(--brand-primary-soft);\n  color: var(--brand-primary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%23008BB1' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  transition: transform var(--dur) var(--ease-out);\n}\n.faq-list .faq-item[open] summary::after { transform: rotate(-180deg); }\n.faq-list .faq-item .faq-body {\n  padding: 0 24px 24px;\n  color: var(--ink-600);\n  font-size: 15px;\n  line-height: 1.75;\n}\n\n/* =========================================================================\n   Footer\n   ========================================================================= */\n\n.footer {\n  background: linear-gradient(180deg, var(--brand-dark) 0%, var(--brand-dark-2) 100%) !important;\n  color: rgba(255, 255, 255, 0.65);\n  padding-top: 0;\n  padding-bottom: 0;\n  border-top: none;\n  position: relative;\n}\n/* A slim brand-gradient signature line at the very top edge, where the page\n   content (white) meets the footer (dark) — a common premium-footer touch. */\n.footer::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 0 auto 0;\n  height: 3px;\n  background: linear-gradient(90deg, var(--brand-primary) 0%, var(--brand-secondary) 100%);\n  z-index: 1;\n}\n/* Template reserved 200px of top padding here for its decorative wave graphic\n   (removed above, legacy purple) — that space was never reclaimed. */\n.footer .footer-top {\n  padding: 64px 0 12px !important;\n}\n/* Template's decorative wave (footer-shape.png) shipped in the legacy purple —\n   the gradient + top accent line above already give the footer a defined edge. */\n.footer::after { content: none !important; }\n.footer .footer-title,\n.footer h3.footer-title {\n  color: #fff;\n  font-family: var(--font-sans);\n  font-weight: 700;\n  font-size: 12px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  margin-bottom: 14px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.14);\n}\n/* Same story: template's purple footer-line.png underline duplicated the border above. */\n.footer .widget .footer-title::after { content: none !important; }\n.footer .widget ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.footer .widget ul li { margin-bottom: 9px; }\n.footer .widget ul li a,\n.footer .widget ul li a span {\n  color: rgba(255, 255, 255, 0.65);\n  font-size: 14px;\n  font-weight: 500;\n  transition: color var(--dur) var(--ease-out);\n}\n.footer .widget ul li a:hover,\n.footer .widget ul li a:hover span { color: #fff; }\n.footer .widget ul li a.footer-view-all,\n.footer .widget ul li a.footer-view-all span {\n  color: #4FC3E0;\n  font-weight: 700;\n}\n.footer .widget ul li a.footer-view-all:hover,\n.footer .widget ul li a.footer-view-all:hover span { color: #fff; }\n.footer .ft-contact p { color: rgba(255, 255, 255, 0.55); font-size: 14px; line-height: 1.7; }\n.footer .foot-contact {\n  align-items: flex-start !important;\n  gap: 12px !important;\n  padding: 4px 0;\n}\n.footer .foot-contact > span:first-child {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n.footer .foot-contact a, .footer .foot-contact span.fw-medium {\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 14px;\n  padding-top: 4px;\n  line-height: 1.5;\n  transition: color var(--dur) var(--ease-out);\n}\n.footer .foot-contact a:hover { color: #fff; }\n.footer .footer-social-link ul li a {\n  border-radius: 10px !important;\n  background: rgba(255, 255, 255, 0.08) !important;\n  border: 1px solid rgba(255, 255, 255, 0.14) !important;\n  color: #fff !important;\n  box-shadow: none;\n}\n.footer .footer-social-link ul li a:hover {\n  background: var(--brand-primary) !important;\n  color: #fff !important;\n  border-color: var(--brand-primary) !important;\n  transform: translateY(-1px);\n}\n.footer .footer-bottom {\n  padding: 22px 0;\n  border-top: 1px solid rgba(255, 255, 255, 0.12);\n}\n.footer .copyright-text { color: rgba(255, 255, 255, 0.5); font-size: 13px; }\n.footer .copyright-text a { color: rgba(255, 255, 255, 0.7); }\n.footer .copyright-text a:hover { color: #fff; }\n.footer .custom-links a span { color: rgba(255, 255, 255, 0.6); font-size: 13px; transition: color var(--dur) var(--ease-out); }\n.footer .custom-links a:hover span { color: #fff; }\n.footer .pt-img1, .footer .pt-img2, .footer .pt-img3, .footer .pt-img4 { opacity: 0.12; }\n\n/* =========================================================================\n   Team\n   ========================================================================= */\n\n.team-member {\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  background: var(--surface);\n  border: 1px solid var(--ink-200);\n  transition: all var(--dur) var(--ease-out);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.team-member:hover { box-shadow: var(--shadow-md); transform: translateY(-3px); }\n.team-member .team-media {\n  aspect-ratio: 1 / 1;\n  overflow: hidden;\n  background: var(--brand-primary-soft);\n  /* Template's own .team-member .team-media rule (App.css) chains 2 classes —\n     equal or higher specificity than this file's old bare `.team-media`\n     selector, so its `padding: 20%` kept winning and shrank the photo into a\n     fraction of the square, leaving a wide soft-blue border around it.\n     Matching the selector here (not just relying on cascade order) is what\n     actually overrides it. */\n  padding: 0;\n}\n.team-member .team-media img {\n  /* Same specificity problem for the image itself: the template masks every\n     team photo into its decorative hexagon (`mask-image: url(shape3.png)`)\n     and adds `padding-top: 40px`, both sized for template stock photography,\n     not these headshots — real photos ended up cropped into a tiny hexagon\n     island floating in a sea of the container's background color. Photos are\n     plain rectangular avatars in this design, so drop the mask entirely. */\n  -webkit-mask-image: none;\n  mask-image: none;\n  padding-top: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform var(--dur-slow) var(--ease-out);\n}\n.team-member .team-media:before,\n.team-member .team-media:after {\n  /* Decorative background blobs (shape1.png/shape2.png) meant to peek out\n     around the hexagon-masked photo — with the mask gone there's no gap for\n     them to show through, and `.team-media`'s own overflow: hidden clips them. */\n  content: none;\n}\n.team-member:hover .team-media img { transform: scale(1.04); }\n.team-info {\n  padding: 22px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n.team-info h4 { font-family: var(--font-display); font-size: 17px; margin-bottom: 4px; letter-spacing: -0.01em; }\n.team-info .text-secondary { font-size: 12px; letter-spacing: 0.10em; text-transform: uppercase; font-weight: 600; }\n.team-info .social-media { list-style: none; padding: 0; margin: 16px 0 0; display: flex; justify-content: center; gap: 8px; }\n.team-info .social-media a {\n  width: 36px; height: 36px; border-radius: 10px;\n  border: 1px solid var(--ink-200);\n  color: var(--brand-primary);\n  display: inline-flex; align-items: center; justify-content: center;\n  transition: all var(--dur) var(--ease-out);\n}\n.team-info .social-media a:hover { background: var(--brand-primary); color: #fff; border-color: var(--brand-primary); }\n\n/* =========================================================================\n   Home about section\n   ========================================================================= */\n\n.about-area {\n  padding: 96px 0 !important;\n}\n.about-area .heading-bx .title {\n  font-family: var(--font-display);\n  font-size: var(--fs-h1);\n  margin-bottom: 16px;\n  letter-spacing: -0.025em;\n}\n.about-area .heading-bx .title em {\n  font-family: var(--font-serif);\n  font-style: italic;\n  font-weight: 400;\n  color: var(--brand-primary);\n}\n.about-area .heading-bx p { color: var(--ink-500); font-size: 1.0625rem; line-height: 1.7; }\n\n/* About portrait — mirrors the hero's offset-card + floating-chip treatment\n   so the page reads as one design system rather than two different styles. */\n.about-portrait {\n  position: relative;\n  padding: 16px 16px 40px 16px;\n}\n.about-portrait::before {\n  content: \"\";\n  position: absolute;\n  inset: 36px 0 16px 36px;\n  background: var(--grad-brand);\n  border-radius: var(--radius-2xl);\n  transform: rotate(3deg);\n  z-index: 0;\n  box-shadow: var(--shadow-lg);\n}\n.about-portrait img {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  height: auto;\n  aspect-ratio: 4 / 4.3;\n  object-fit: cover;\n  border-radius: var(--radius-2xl);\n  box-shadow: var(--shadow-lg);\n  background: #fff;\n  display: block;\n}\n.about-portrait-chip {\n  position: absolute;\n  z-index: 2;\n  left: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  background: var(--surface);\n  border-radius: var(--radius-lg);\n  padding: 16px 20px;\n  box-shadow: var(--shadow-lg);\n  max-width: 240px;\n}\n.about-portrait-chip .value {\n  font-family: var(--font-serif);\n  font-size: 1.5rem;\n  color: var(--brand-primary);\n  line-height: 1;\n}\n.about-portrait-chip .label {\n  font-size: 12.5px;\n  color: var(--ink-600);\n  font-weight: 600;\n  line-height: 1.4;\n  margin-top: 6px;\n}\n@media (max-width: 991px) {\n  .about-portrait-chip { max-width: 220px; padding: 14px 18px; }\n}\n\n.feature-container.feature-bx1 {\n  padding: 22px;\n  border: 1px solid var(--ink-200);\n  border-radius: var(--radius-lg);\n  background: var(--surface);\n  transition: all var(--dur) var(--ease-out);\n}\n/* Template gave feature1–4 a rainbow of decorative corner glows (cyan/green/pink/purple)\n   via :after — kill them all so every value card matches the brand's 2-color palette. */\n.feature-bx1::after,\n.feature-bx1.feature1::after,\n.feature-bx1.feature2::after,\n.feature-bx1.feature3::after,\n.feature-bx1.feature4::after {\n  content: none !important;\n}\n.feature-container.feature-bx1:hover {\n  border-color: var(--brand-primary);\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n}\n.feature-container.feature-bx1 .icon-md {\n  width: 52px; height: 52px;\n  border-radius: 14px;\n  background: var(--brand-primary-soft);\n  display: inline-flex; align-items: center; justify-content: center;\n  margin-bottom: 14px;\n}\n.feature-container.feature-bx1 .ttr-title {\n  font-family: var(--font-display);\n  font-size: 16px;\n  color: var(--ink-900);\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n\n.about-thumb-area ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n.about-thumb-area ul li img {\n  width: 100%;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  aspect-ratio: 1 / 1;\n  object-fit: cover;\n}\n\n/* Contact page icon boxes */\n.feature-bx4 {\n  padding: 32px 24px;\n  border: 1px solid var(--ink-200);\n  border-radius: var(--radius-lg);\n  background: var(--surface);\n  text-align: center;\n  transition: all var(--dur) var(--ease-out);\n}\n.feature-bx4:hover { border-color: var(--brand-primary); box-shadow: var(--shadow-md); transform: translateY(-2px); }\n.feature-bx4 .feature-icon {\n  width: 60px; height: 60px;\n  border-radius: 16px;\n  background: var(--brand-primary-soft);\n  display: inline-flex; align-items: center; justify-content: center;\n  margin: 0 auto 14px;\n}\n.feature-bx4 .feature-icon img { width: 30px; height: 30px; object-fit: contain; }\n.feature-bx4 .ttr-title { font-family: var(--font-display); margin-bottom: 8px; letter-spacing: -0.01em; }\n\n/* Kill decorative shapes on home sections */\n.about-area .pt-img1,\n.about-area .pt-img2,\n.about-area .pt-img3,\n.about-area .pt-img4,\n.about-area .pt-img5,\n.team-wraper .pt-img1,\n.team-wraper .pt-img2,\n.team-wraper .pt-img3,\n.team-wraper .pt-img4,\n.team-wraper .pt-img5 { display: none !important; }\n.testimonial-wraper .pt-img1,\n.testimonial-wraper .pt-img2,\n.testimonial-wraper .pt-img3,\n.testimonial-wraper .pt-img4 { opacity: 0.25; }\n\n/* =========================================================================\n   Services slider (Why Clametis)\n   ========================================================================= */\n\n.service-wraper .heading-bx { text-align: center; margin-bottom: 40px; }\n.service-wraper .heading-bx h6 { justify-content: center; }\n.service-wraper .feature-bx2 {\n  padding: 32px 28px;\n  border: 1px solid var(--ink-200);\n  border-radius: var(--radius-lg);\n  background: var(--surface);\n  height: 100%;\n  transition: all var(--dur) var(--ease-out);\n  text-align: center;\n}\n.service-wraper .feature-bx2:hover {\n  border-color: var(--brand-primary);\n  box-shadow: var(--shadow-md);\n  transform: translateY(-4px);\n}\n.service-wraper .feature-bx2 .feature-box-xl {\n  width: 84px; height: 84px;\n  border-radius: 20px;\n  background: var(--brand-primary-soft);\n  display: inline-flex; align-items: center; justify-content: center;\n  margin: 0 auto 18px;\n}\n.service-wraper .feature-bx2 .feature-box-xl svg { max-width: 40px; max-height: 40px; }\n.service-wraper .feature-bx2 .ttr-title {\n  font-family: var(--font-display);\n  color: var(--ink-900); margin-bottom: 8px;\n  font-size: 17px; letter-spacing: -0.01em;\n}\n.service-wraper .feature-bx2 p { color: var(--ink-500); font-size: 14px; margin: 0; }\n\n.slick-arrow { display: none !important; }\n\n/* =========================================================================\n   Partners\n   ========================================================================= */\n\n.our-partner-box {\n  padding: 20px 32px;\n  border: 1px solid var(--ink-200);\n  border-radius: var(--radius-md);\n  background: var(--surface);\n  transition: all var(--dur) var(--ease-out);\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.our-partner-box img {\n  max-height: 50px;\n  object-fit: contain;\n  filter: grayscale(30%);\n  opacity: 0.85;\n  transition: all var(--dur) var(--ease-out);\n}\n.our-partner-box:hover { border-color: var(--brand-primary); box-shadow: var(--shadow-sm); }\n.our-partner-box:hover img { filter: none; opacity: 1; }\n\n/* =========================================================================\n   Back-to-top + WhatsApp float\n   ========================================================================= */\n\n.scroltop {\n  background: var(--brand-primary) !important;\n  color: #fff !important;\n  border-radius: 12px !important;\n  box-shadow: var(--shadow-md) !important;\n}\n.wa-float {\n  position: fixed;\n  /* Stacked above .back-to-top (bottom:15px, 45px tall) so the two never overlap. */\n  bottom: 76px; right: 24px;\n  z-index: 999;\n  background: #25D366;\n  color: #fff;\n  border-radius: 16px;\n  width: 56px; height: 56px;\n  display: inline-flex; align-items: center; justify-content: center;\n  box-shadow: var(--shadow-md);\n  font-size: 24px;\n}\n.wa-float:hover { background: #128C7E; color: #fff; transform: translateY(-3px); box-shadow: var(--shadow-lg); }\n\n/* Realign the template's back-to-top button under the WhatsApp float and match its radius. */\nbutton.back-to-top {\n  right: 24px !important;\n  bottom: 15px !important;\n  border-radius: 16px !important;\n  width: 48px !important;\n  height: 48px !important;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n}\n\n.sr-only {\n  position: absolute; width: 1px; height: 1px;\n  padding: 0; margin: -1px; overflow: hidden;\n  clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;\n}\n\n/* Motion respect */\n@media (prefers-reduced-motion: reduce) {\n  *, *::before, *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n  .animate-wave, .animate1, .animate2, .animate3, .animate4,\n  .animate5, .animate-rotate, [class^=\"animate-\"], [class*=\" animate-\"] {\n    animation: none !important;\n  }\n}\n\n/* =========================================================================\n   Mobile carousels — some card grids (4-6 short items) stacked into very\n   long single-column scrolls on mobile with nothing but repeated cards for\n   a full screen or more at a time. Below 767px, `.mobile-carousel` turns\n   the row into a horizontal, snap-scrolling strip instead — same cards,\n   a fraction of the scroll height, and the partial next-card peek signals\n   it's swipeable. Desktop/tablet grid layout (untouched) still applies\n   above this breakpoint.\n   ========================================================================= */\n@media (max-width: 767px) {\n  .mobile-carousel {\n    display: flex !important;\n    flex-wrap: nowrap !important;\n    overflow-x: auto !important;\n    /* Leaving overflow-y unset would compute to `auto` too (CSS resolves a\n       'visible' axis to 'auto' whenever the other axis isn't 'visible'),\n       turning this into a vertical scroll container as well. With nothing\n       inside it to vertically overflow that traps rather than scrolls — a\n       trackpad/mouse-wheel scroll (an iPad with a trackpad, e.g.) landing on\n       the strip stops moving the page entirely. Pin it to hidden so vertical\n       scroll always passes through to the page; only horizontal is ours. */\n    overflow-y: hidden;\n    scroll-snap-type: x mandatory;\n    -webkit-overflow-scrolling: touch;\n    margin-left: calc(-1 * var(--container-pad)) !important;\n    margin-right: calc(-1 * var(--container-pad)) !important;\n    padding-left: var(--container-pad) !important;\n    padding-right: var(--container-pad) !important;\n    padding-bottom: 12px;\n    scrollbar-width: none;\n  }\n  .mobile-carousel::-webkit-scrollbar { display: none; }\n  .mobile-carousel > * {\n    flex: 0 0 82% !important;\n    max-width: 82% !important;\n    scroll-snap-align: start;\n  }\n}\n\n/* =========================================================================\n   Mobile refinements\n   ========================================================================= */\n\n@media (max-width: 767px) {\n  .menu-bar > .container-fluid { height: 72px !important; padding-left: 20px !important; padding-right: 20px !important; }\n  .header .menu-logo img, .rs-nav .menu-logo img { height: 40px !important; max-height: 40px !important; }\n  .header.is-stuck .menu-bar > .container-fluid { height: 60px !important; }\n  .header.is-stuck .menu-logo img, .rs-nav.is-stuck .menu-logo img { height: 34px !important; max-height: 34px !important; }\n  .main-banner { padding: 112px 0 60px !important; }\n  .main-banner h1 { font-size: 2.25rem !important; }\n  .main-banner .banner-img { margin-top: 32px; padding: 12px !important; }\n  .main-banner .banner-img::before { inset: 12px !important; }\n  .page-banner { padding: 32px 0 18px !important; }\n  .page-banner h1 { font-size: 1.625rem; }\n  .stats-strip { padding: 48px 0; }\n  .stats-strip .stat-value { font-size: 2.25rem; }\n  .prefooter-cta { margin: 48px 12px; padding: 48px 24px; }\n  .prefooter-cta h2 { font-size: 1.75rem; }\n  .testimonial-bx { padding: 32px 24px; }\n  .testimonial-bx .testimonial-content p { font-size: 1.15rem; }\n  .blog-detail-card .info-bx { padding: 24px; }\n  .form-wraper { padding: 24px; }\n  .distributor-filters { flex-direction: column; gap: 12px; }\n  .distributor-filters > * { width: 100% !important; }\n}\n\n/* =========================================================================\n   Kill legacy floating shape animations everywhere they clash\n   ========================================================================= */\n\n.page-content > .banner-wraper .pt-img1,\n.page-content > .banner-wraper .pt-img2,\n.page-content > .banner-wraper .pt-img3 { opacity: 0.20; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
